import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-speakers',
  templateUrl: './speakers.component.html',
  styleUrls: ['./speakers.component.scss']
})
export class SpeakersComponent {
  @ViewChild('speakerModal') speakerModal!: ElementRef;
  selectedSpeaker: any;
  defaultImage = 'assets/images/thumb/no-thumb.jpeg';

  speakers = [
    // {
    //   speakerID: 'S151',
    //   speaker: 'Vivek R',
    //   profile: '',
    //   speakerdesc: '',
    //   thumb: 'assets/images/thumb/bharathsankar.jpg',
    //   facebook: '',
    //   twitter: '',
    //   linkedIn: 'https://www.linkedin.com/in/bharathsg202/',
    //   email: '',
    //   events: {
    //     event1: 'T113'
    //   }
    // },
    {
      speakerID: 'S150',
      speaker: 'Bharath Shankar Ganapathy',
      profile: 'Senior Program Manager- FIDE',
      speakerdesc: 'Bharath refined his unique skill set at early stage tech start-ups. A post-MBA career as a Program Manager challenged him with the management of diverse projects with multi-disciplinary teams. A feat he used to garner invaluable Program Management expertise. During his 4 years with the Risk Advisory practice at Deloitte India, Bharath Shankar Ganapathy soon showcased his finesse in developing accelerator tools that aid internal initiatives. Within 3 years, he established himself as the leader of a talented off-shore IT Security team serving global clients primarily across Europe & Canada, by implementing and maintaining client SAP ERP modules. He is now a Senior Program Manager at FIDE - the organization that birthed the groundbreaking Beckn Open Protocol.',
      thumb: 'assets/images/thumb/bharathsankar.jpg',
      facebook: '',
      twitter: '',
      linkedIn: 'https://www.linkedin.com/in/bharathsg202/',
      email: '',
      events: {
        event1: 'T113'
      }
    },
    {
      speakerID: 'S149',
      speaker: 'SurendraSingh S',
      profile: 'Product At EkStep',
      speakerdesc: 'An expert enabler of large scale societal transformation by developing open source Digital Public Goods (DPG), SurendraSingh is also a Teach For India alumnus. He headed several complex projects including large-scale Product Marketing, AI-powered digitization, and Content Crowdsourcing with a profound business acumen - a result of his relentless pursuit of understanding how businesses grow by mining the connection between a product and its intended audience. He has led cross-functional teams to develop Adaptive learning games, Learning platform with Content creation & curation tools, Consumption (i.e. Learner) app, and other capabilities. SurendraSingh specializes in leveraging high-trust, low-cost Decentralized Open Network & Verifiable Credentials. He currently focuses on enabling learning & livelihood for everyone as the Product Manager at EkStep Foundation.',
      thumb: 'assets/images/thumb/surendrasingh.jpg',
      facebook: '',
      twitter: '',
      linkedIn: 'https://www.linkedin.com/in/surendrasinghs/',
      email: '',
      events: {
        event1: 'T113'
      }
    },
    {
      speakerID: 'S1',
      speaker: 'Nitin Nair',
      profile: 'Senior Vice President at ONDC',
      speakerdesc: `Nitin Nair is a Senior Vice President and leads the network expansion initiative pan India for Mobility, Transportation, and Travel along with the overall South India business for Open Network for Digital Commerce (ONDC).
Previously, he held roles with Nissan Motors, Uber, and EY where he managed multiple teams solving for connected cars, tech- enabled urban mobility, and business advisory across India, the Middle East, Europe, and Oceania.With an overall experience of over 20 + years, he has a proven track record for delivering impactful results with organizations and teams working on tip - of - the - spear problem statements across varying geographies and scales.
As an industry and function leader, he has been instrumental in ONDC forging successful collaborations with various Central and State Government entities, large technology platforms, and startups.He is an alumnus of the University of Pune and IIM Kozhikode.`,
      thumb: 'assets/images/thumb/Nitin-Nair.jpg',
      facebook: '',
      twitter: '',
      linkedIn: 'https://www.linkedin.com/in/nitin-nair-2002/',
      email: '',
      events: {
        event1: 'T158'
      }
    },
    {
      speakerID: 'S148',
      speaker: 'Thomson Skariah Thayil',
      profile: 'CEO of Rapidor',
      speakerdesc: `Thomson is the Co-Founder and CEO of placeorder.com, the first B2B Platform on the ONDC Network empowering small, medium and large enterprises.  Placeorder.com is today responsible for the significant chunk of B2B orders on the network and enabling many more players to join on the Network.
Besides demonstrating significant traction by enabling businesses to be discovered, orders to be placed,  received and fulfilled via their Buyer and Seller App, they are now bringing in the capability for SMEs to easily avail Business Loans from multiple Banks via the ONDC Network, significantly reducing the friction to close B2B deals.
Thomson and his co-founders closely work with the core team at ONDC, focusing on enabling business relevant usecases and together are expanding the horizons.`,
      thumb: 'assets/images/thumb/Thomson-Skariah-Thayil.jpg',
      facebook: '',
      twitter: '',
      linkedIn: 'https://www.linkedin.com/in/thomsonskariah/',
      email: '',
      events: {
        event1: 'T158'
      }
    },
    {
      speakerID: 'S147',
      speaker: 'Sony John Bronzon',
      profile: 'Heads Training and Development at ALLONTM.',
      speakerdesc: 'As a Corporate Trainer and Design Thinking enthusiast, with 15 years of corporate experience in IT and L&D arenas, Sony John Bronzon heads Training and Development at ALLONTM. Having served previously in the capacity of Assistant Director of Learning and Development(L&D) at EY, Sony is currently involved extensively in conducting Design Studio for Product Innovation, Business Services Innovation, Strategy Development and preparing futuristic roadmaps. He is one of the very few trainers in the country who is a CPLP (Certified Professional in Learning and Performance) from the Association for Talent Development, USA.',
      thumb: 'assets/images/thumb/Sony-John-Bronzon.jpg',
      facebook: 'https://www.facebook.com/sonycec',
      twitter: '',
      linkedIn: 'https://www.linkedin.com/in/sonyjohnbronzon/',
      email: '',
      events: {
        event1: 'T157'
      }
    },
    {
      'speakerID': 'S76',
      'speaker': 'Jubin Jose',
      'profile': 'Cedex Technologies LLP',
      'speakerdesc': 'Jubin Jose is a chatbot developer at Cedex Technologies LLP and a Machine Learning enthusiast. A programmer by choice, he’s interested in Creative Coding and teaching kids online. He believes in the importance of Indic ML and is an active contributor to the free software community.',
      'thumb': 'assets/images/thumb/Jubin-Jose.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/jubin-jose-cet/',
      'email': '',
      'events': {
        'event1': 'C10'
      }
    },
    {
      'speakerID': 'S77',
      'speaker': 'Gopikrishnan V',
      'profile': 'Founder, BuildNext',
      'speakerdesc': 'Mr. Gopikrishnan V is the founder of the internet based building material procurement platform, BuildNext. He graduated B.Arch (Hons.) from IIT Kharagpur, winning the presitigious ‘B.C. Roy Gold Medal’ for the Best Outgoing Student. He further went on to do his post-graduation from IIM Bangalore. He is a registered architect with the Council of Architecture, India, and a LEED accredited professional.',
      'thumb': 'assets/images/thumb/Gopikrishnan-V.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/gopikrishnanv/',
      'email': '',
      'events': {
        'event1': 'C12'
      }
    },
    {
      'speakerID': 'S78',
      'speaker': 'Manu Krishnan',
      'profile': 'Co-founder of DayScholars Innovations Pvt. Ltd',
      'speakerdesc': 'A technology and free software enthusiast, Manu Krishnan is a Solutions Architect and Co-founder of DayScholars Innovations Pvt. Ltd. A programmer by choice, he started working on web technologies during school days and built several websites, later moving focus to application development. Preferring his codes in PHP and Python, his present areas of interest include DevOps, Containers, Federation and Distributed Communication Platforms. He is also an active member of many free software communities.',
      'thumb': 'assets/images/thumb/Manu-Krishnan.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/tvmanukrishnan/',
      'email': '',
      'events': {
        'event1': 'K9'
      }
    },
    {
      'speakerID': 'S79',
      'speaker': 'Abhiram A',
      'profile': 'Unity3D Ambassador, Unity India',
      'speakerdesc': 'An Immersive Technology enthusiast, Abhiram A. is a Unity3D Ambassador for Unity India and works as a Senior Software Developer for VR/AR Tech at UST Global. He has worked as an AR/VR Consultant for Onbyz and also as a Junior Research Fellow - VR at Future Technologies Lab, Kerala StartUp Mission. He is a Udacity VR Nanodegree graduate and a Unity Certified Developer.',
      'thumb': 'assets/images/thumb/Abhiram-A.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/abhir6m/',
      'email': '',
      'events': {
        'event1': 'K10',
        'event2': 'T62'
      }
    },
    {
      'speakerID': 'S80',
      'speaker': 'Alex Devassy',
      'profile': 'Senior Blockchain Engineer at Serventire Global',
      'speakerdesc': 'Senior Blockchain Engineer at Serventire Global and Core member of KBA-Kerala Blockchain Academy, Alex specializes in Hyperledger and Ethereum. He has been a member of the winning team in the Open Innovation Blockchain Hackathon, conducted by BestofBlocks Inc. at IIT Delhi. He also has wide experience in the field of IoT Blockchain integration and Cyber Security, working with Ernst and Young and UST-Global. He is also a Certified Ethical Hacker. He keeps interest in not only enhancing his knowledge but also in mentoring students in the field of Blockchain.',
      'thumb': 'assets/images/thumb/Alex-Devassy.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/alex-devassy-358421138/',
      'email': '',
      'events': {
        'event1': 'K11'
      }
    },
    {
      'speakerID': 'S81',
      'speaker': 'Fariz Rahman',
      'profile': 'Deep Learning Engineer, Skymind',
      'speakerdesc': 'Fariz Rahman is a Deep Learning Engineer at Skymind. His interest is in Artificial Intelligence, Deep learning to be specific. He is passionate about open source software libraries and have written a bunch of them. One of his goals is to democratize deep learning, make it accessible to small businesses and ametuer developers by writing simple APIs to complex deep learning techniques, as well as doing solid search and heavily contributing to open source projects like Keras. ',
      'thumb': 'assets/images/thumb/Fariz-Rahman.jpg',
      'facebook': '',
      'twitter': 'https://twitter.com/farizrahman4u?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/fariz-rahman-2b20443a/',
      'email': '',
      'events': {
        'event1': 'K12'
      }
    },
    {
      'speakerID': 'S82',
      'speaker': 'Hari S. Pillai',
      'profile': 'Technical Lead at Perfomatix',
      'speakerdesc': 'Hari S. Pillai is the Technical Lead of Perfomatix. Having over 9 years of industry experience, Hari works on a variety of technology stacks and is a technology evangelist for Angular and Node JS based application stacks. He has also worked for multiple Fortune 100 companies.',
      'thumb': 'assets/images/thumb/Hari-s-pillai.jpeg',
      'facebook': '',
      'twitter': '',
      'linkedIn': '',
      'email': '',
      'events': {
        'eventID': 'T64'
      }
    },
    {
      'speakerID': 'S82',
      'speaker': 'Rejin Narayanan',
      'profile': 'founder, Ingen Robotics.',
      'speakerdesc': 'Rejin Narayanan is a roboticist and serial entrepreneur, and is the founder of the consumer robotics startup - Ingen Robotics. Their first product is a fully automatic roti making robot, which was designed and developed in Trivandrum. Rejin has rich professional experience, and has worked in multicultural environments. He has several paper publications and patent applications to his credit. Rejin holds a masters in Autonomous Systems from the Bonn-Rhein-Sieg University of Applied Sciences in Germany, and a bachelors degree in Electrical and Electronics Engineering from the University of Kerala. Rejin is very much a hands on person, with skills in software, electronics, mechanics, and product design.',
      'thumb': 'assets/images/thumb/Rejin-Narayanan.jpg',
      'facebook': 'https://www.facebook.com/rejin.narayanan.5     ',
      'twitter': 'https://twitter.com/rejinns?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/rejin/',
      'email': '',
      'events': {
        'eventID': 'T65'
      }
    },
    {
      'speakerID': 'S83',
      'speaker': 'Ajith Kumar M',
      'profile': 'Robotics Developer at TCS-ILP Innovations Lab',
      'speakerdesc': 'Mr Ajithkumar M. is a Robotics Developer working with the CTO team of TCS-ILP Innovations Lab. He has experience in simulation, design and manufacturing of projects pertaining to robotics, automobiles and special purpose machines. He has also worked on the creation and deployment of several socially interactive robots.',
      'thumb': 'assets/images/thumb/Ajith-kumar.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': '',
      'email': '',
      'events': {
        'eventID': 'T66'
      }
    },
    {
      'speakerID': 'S84',
      'speaker': 'Sanu George',
      'profile': 'Senior consultant for Usability engineering at IBS',
      'speakerdesc': 'Sanu George, who is currently a senior consultant for Usability engineering at IBS , and a UX practice head & product strategy professional with experience in building enterprise product UX strategy, design leadership and user research working with some of the largest companies in travel, transportation and logistics industry like Lufthansa Airlines, ANA, Qantas Airways, Korean Air, South African Airways, Shell corporation, etc.',
      'thumb': 'assets/images/thumb/Sanu-George.jpg',
      'facebook': 'http://facebook.com/sanu.george',
      'twitter': 'https://twitter.com/sanugeorge',
      'linkedIn': 'https://www.linkedin.com/in/sanugeorge-ux/',
      'email': '',
      'events': {
        'event1': 'T67',
        'event2': 'C18'
      }
    },
    {
      'speakerID': 'S85',
      'speaker': 'Ajith V Giri',
      'profile': 'Mobile App Developer working at SoftFrit Solutions',
      'speakerdesc': 'A Mobile App Developer working for SoftFrit Solutions, Ajith is an experienced mobile app developer specialized in Kotlin and swift. He has delivered various sessions as part of Kotlin User Group Kozhikode. He also has wide experience in Firebase and building scalable applications using firebases for different projects.',
      'thumb': 'assets/images/thumb/Ajith-V-Giri.jpg',
      'facebook': 'https://www.facebook.com/ajithvgiri',
      'twitter': 'https://twitter.com/ajithvgiri',
      'linkedIn': '',
      'email': '',
      'events': {
        'eventID': 'K13'
      }
    },
    {
      'speakerID': 'S86',
      'speaker': 'Noufal Ibrahim',
      'profile': 'Founder and Director of Hamon Technologies, LLP, Kozhikode',
      'speakerdesc': 'Noufal Ibrahim is a programmer and software designer with over 20 years of experience in Python and related technologies. He is the Founder and Director of Hamon Technologies, LLP in Kozhikode – an infrastucture and automation services firm. He is also a founding partner and senior trainer at Pipal Academy, LLP – A corporate training firm specialising in niche trainings. He is also a member of the Python Software Foundation. He was the founder of PyCon India which has grown to be the largest national level PyCon outside the US. He also does student training and mentoring via. The Lycaeum - a mentoring program based in Kozhikode. In his free time, he enjoys practicing calligraphy.',
      'thumb': 'assets/images/thumb/Noufal-ibrahim.jpg',
      'facebook': '',
      'twitter': 'https://twitter.com/noufalibrahim',
      'linkedIn': 'https://in.linkedin.com/in/noufalibrahim',
      'email': '',
      'events': {
        'event1': 'K15',
        'event2': 'K17'
      }
    },
    {
      'speakerID': 'S88',
      'speaker': 'Ravi Padmaraj',
      'profile': 'Architect at QBurst Technologies',
      'speakerdesc': 'Ravi Padmaraj is an Architect with QBurst Technologies focusing on data engineering and ETL systems. He is experienced in building large volume real time data transformation and analytics engines using AWS, Azure and in house clusters. His previous client engagements include British Telecom, Apple, Genesys etc.',
      'thumb': 'assets/images/thumb/Ravi-Padmaraj.jpeg',
      'facebook': '',
      'twitter': '',
      'linkedIn': '',
      'email': '',
      'events': {
        'eventID': 'K18'
      }
    },
    {
      'speakerID': 'S89',
      'speaker': 'Jobin C S',
      'profile': 'Co-Founder & CEO of Tenderwoods',
      'speakerdesc': 'Jobin CS is the Co-Founder & CEO of Tenderwoods. He started his entrepreneur career with a robotic company and has served many key positions in startup and corporates. A trainer by passion, he has given training in corporate including Samsung, HP, Wipro etc. Having spent 5 years in the field of Technical Training, he is an excellent Startup Guru and Motivational Speaker who has published several technical blogs, articles, games and apps.',
      'thumb': 'assets/images/thumb/Jobin-CS.jpg',
      'facebook': 'https://www.facebook.com/jobin.thodupuzha.5',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/jobin-c-s-26b5b56a/',
      'email': '',
      'events': {
        'eventID': 'C13'
      }
    },
    {
      'speakerID': 'S90',
      'speaker': 'Paul Emil Johnson',
      'profile': 'Founder – AwesomeDaddies Interactive',
      'speakerdesc': 'Design leader with a rich experience in building design systems for enterprise products, Paul Emil Johnson is the founder of AwesomeDaddies Interactive, a product design studio. He has worked with over 50 startups where few of them got acquired and other clients like Vodafone, ICICI, Schindler, Egmont, ATEA etc.',
      'thumb': 'assets/images/thumb/Paul-emil-johnson.jpg',
      'facebook': 'https://www.facebook.com/plemil',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/paulemiljohnson/',
      'email': '',
      'events': {
        'eventID': 'C14'
      }
    },
    {
      'speakerID': 'S91',
      'speaker': 'Roel Vlemmings',
      'profile': 'Founding Partner and the Chief Product Officer at RedBlack Software',
      'speakerdesc': 'Roel Vlemmings is a Founding Partner and the Chief Product Officer at RedBlack Software. Headquartered in the US, RedBlack is a fintech product company and a leading provider of investment management software. The RedBlack platform is currently used by wealth advisors, asset managers, family offices, and private banks to manage more than $500 billion dollars in client assets. Originally from Holland, Roel has more than 20 years’ experience in software product development and has lived in Kerala since 2000. When he is not busy designing new features for the RedBlack platform, Roel can be found travelling to new countries or sailing on the Kerala backwaters.',
      'thumb': 'assets/images/thumb/Roel-Vlemmings.jpg',
      'facebook': 'https://www.facebook.com/roel.vlemmings',
      'twitter': 'https://twitter.com/rvlemmings',
      'linkedIn': 'https://www.linkedin.com/in/rvlemmings/',
      'email': '',
      'events': {
        'eventID': 'C16'
      }
    },
    {
      'speakerID': 'S92',
      'speaker': 'Suresh Balasubramanian',
      'profile': 'Co-founder & CEO at ExpressBase Systems',
      'speakerdesc': 'Suresh Balasubramanian is a BSc Chemistry graduate (1994) from the prestigious Maharaja\'s College, Ernakulam. He started his career with Sun Pharma in 1994 and switched to IT in 1995. He has worked with several IT giants like BMC Software, Microsoft, Covansys, CSC, CSS Corp. and PayPal in India and the US. Co-Founded an IT Start-up in 2012, NetSonic Solutions LLC in the UAE, which had a watered down RAD client-server software with 30+ clients in UAE, Qatar and Bahrain. He exited NetSonic and returned back to India to setup EXPRESSbase Systems P Ltd in Oct 2016. EXPRESSbase is Rapid Application Development & Delivery platform specially targeting Small to Mid-Sized Businesses. He has worked in all the phases of SDLC, wide range of platforms, tools & languages and has extensive leadership/management experience.',
      'thumb': 'assets/images/thumb/Suresh-balasubramanian.jpg',
      'facebook': 'https://www.facebook.com/suresh.balasubra',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sureba73/',
      'email': '',
      'events': {
        'eventID': 'C17'
      }
    },
    {
      'speakerID': 'S93',
      'speaker': 'Afsal Muttikkal',
      'profile': 'Automation Head at Genrobotic Innovations',
      'speakerdesc': 'With experience in Industrial automation and a demonstrated history of managing and working in the electrical and electronic manufacturing and automation industry, Mr. Afsal is skilled in Embedded products, UX Development, Qt, Electron, and Python among other things. He currently heads the automation department at Genrobotic Innovations.',
      'thumb': 'assets/images/thumb/Afsal.jpg',
      'facebook': 'https://www.facebook.com/Afsal.afzm',
      'twitter': 'https://twitter.com/Afsalmafz',
      'linkedIn': 'https://www.linkedin.com/in/afsalmuttikkal/',
      'email': 'afsal@genrobotics.org',
      'events': {
        'eventID': 'T68'
      }
    },
    {
      'speakerID': 'S94',
      'speaker': 'GeorgeKutty George',
      'profile': 'CEO, Lookings Soft.<br>Mentor, Reacthub',
      'speakerdesc': 'Having years of experience in building Native & React Mobile Apps. Georgekutty is a regular trainer in Reacthub. His current interests are IOT, blockchain and Server Architecture Designing.',
      'thumb': 'assets/images/thumb/georgekutty-george.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/georgekutty-george-a558a788/',
      'email': '',
      'events': {
        'event1': 'C19',
        'event2': 'K19'
      }
    },
    {
      'speakerID': 'S96',
      'speaker': 'Sabeer Sulaiman',
      'profile': 'Technical lead, Fantacode',
      'speakerdesc': 'A technology enthusiast who strives to find unique and useful solutions to technical challenges, Sabeer is a technical lead at FantaCode, focusing on Web and Mobile Development. He is tasked with choosing the right technical stack and architecture for the products developed at Fantacode and has been involved with Angular and other Frontend frameworks for over three years. He is experienced in designing and developing various production ready solutions that use Angular for the frontend. As a person interested in new technology, he is trying to learn, evaluate and spread the word about new technologies as they come out.',
      'thumb': 'assets/images/thumb/sabeer.jpg',
      'facebook': 'https://www.facebook.com/sabeersulaimanpv',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sabeersulaiman/',
      'email': 'sabeer@fantacode.com',
      'events': {
        'eventID': 'K20'
      }
    },
    {
      'speakerID': 'S97',
      'speaker': 'Mahroof Ali',
      'profile': 'Founder, Tensorbot Innovations',
      'speakerdesc': 'Mahroof Ali P. A. is an electronics and communication engineer and the founder of Tensorbot Innovation, based in Trivandrum and co-founder of an NGO named Ignite India, started to promote socially committed engineers. Tensorbot Innovation has several engagements with leading IT companies in products and research related to machine learning, robotics and embedded electronics. He was awarded the best innovative idea award at startup i3 by Kerala startup mission on January 2017.',
      'thumb': 'assets/images/thumb/Mahroof-K.jpg',
      'facebook': 'https://www.facebook.com/mahroof.alikhan',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/mahroof-ali-1991a9137/',
      'email': 'ali@tensorbot.in',
      'events': {
        'event1': 'T70',
        'event2': 'C22'
      }
    },
    {
      'speakerID': 'S98',
      'speaker': 'Nirmal Vyas',
      'profile': 'Web designer and developer<br>Consultant, passionate coder and speaker',
      'speakerdesc': 'Nirmal is a Web / Mobile Developer, Freelance Consultant, Passionate coder and speaker, based in Kochi, Kerala with over a decade worth of experience in developing websites and custom web applications and proficient in working with mobile applications as well. An expert in Website and Web Applications development with PHP 7, Laravel 5 and Codeigniter 3 his works includes and not limited to Yii Framework 2 and MySQL Knowledge + Web 2.0 ( applications ) development + Backbone.js, Angular JS , HTML5, MongoDB, Nodejs, Phonegap, and Ionic 3.',
      'thumb': 'assets/images/thumb/nirmal-vyas.jpg',
      'facebook': 'https://www.facebook.com/nirmal.vyas.90',
      'twitter': '',
      'linkedIn': '',
      'email': 'nirmalkamath@gmail.com',
      'events': {
        'event1': 'C21',
        'event2': 'T71'
      }
    },
    {
      'speakerID': 'S99',
      'speaker': 'Rijin Ramesh',
      'profile': 'Co-founder and head of product and technology, Articbot Pvt Ltd',
      'speakerdesc': 'Being the Co-founder and head of product and technology of Articbot private limited, Rijin Ramesh has more than 5 years of experience in Microsoft .Net framework and technologies. Specialized in Researching in Conversational AI and Machine learning algorithms, he has also built an in-house Chatbot framework for Articbot.',
      'thumb': 'assets/images/thumb/rijin_ramesh.jpg',
      'facebook': 'https://www.facebook.com/rijin.ramesh.14',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/rijin-ramesh-31809375/',
      'email': 'rijinramesh1990@gmail.com',
      'events': {
        'eventID': 'K21'
      }
    },
    {
      'speakerID': 'S100',
      'speaker': 'Ashik Salman',
      'profile': 'Co-founder at Ecart.chat',
      'speakerdesc': 'Ashik is a program architect and backend developer with many years worth of experience on Ruby on Rails. Being a former developer at Truecaller, Ashik has hands on experience in developing mobile payment solutions and backend APIs for payment gateways and mobile payment solutions. He is currently working to build Ecart.chat, a simplified messenger marketing solution for ecommerce sites.',
      'thumb': '',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/ashik-salman-a487a596/',
      'email': 'ashiksp@gmail.com',
      'events': {
        'eventID': 'K22'
      }
    },
    {
      'speakerID': 'S101',
      'speaker': 'Asif Mohammed',
      'profile': 'JS Frontend Engineer, FAYA Innovations',
      'speakerdesc': 'Asif Mohammed is a JS Frontend Engineer at FAYA Innovations Technopark, with immense experience in developing isomorphic Web applications. Currently working in R&D at FAYA, he has worked on several frameworks and are active proponents of gamification.',
      'thumb': 'assets/images/thumb/asif_mohammed.jpg',
      'facebook': 'https://www.facebook.com/Brawlerx',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/asif-mohammed-18b2bb150/',
      'email': 'asif.m@fayausa.com',
      'events': {
        'eventID': 'T72'
      }
    },
    {
      'speakerID': 'S102',
      'speaker': 'Deepu Xavier',
      'profile': 'Co-founder, ZappyHire',
      'speakerdesc': 'Deepu Xavier is the co-founder of ZappyHire, an intelligent autonomous recruitment platform based out of Cochin. He was the Principal Product Manager of Java programming language at Oracle and was featured in the coveted Young Leaders of India List by The Economic Times. He is also a frequent speaker at various international user groups and other technical conference and have worked with companies like Infosys, Bosch, Oracle and RapidValue.',
      'thumb': 'assets/images/thumb/Deepu_xavier.jpg',
      'facebook': 'https://www.facebook.com/deepu.xavier.9',
      'twitter': 'https://twitter.com/deepuxavier',
      'linkedIn': 'https://www.linkedin.com/in/deepu-xavier-8b126330/',
      'email': 'deepu@zappyhire.com',
      'events': {
        'eventID': 'C23'
      }
    },
    {
      'speakerID': 'S103',
      'speaker': 'Sreelakshmy P',
      'profile': 'Assistant Manager at Deloitte India',
      'speakerdesc': 'An OSCP & CEH Certified security Researcher and enthusiast, Sreelakshmy Palliyil is currently associated with Big 4. With Masters in Cyber security, she is an active member and Woman in Appsec Coordinator at OWASP Kerala Chapter.',
      'thumb': 'assets/images/thumb/Sreelakshmy.jpg',
      'facebook': '',
      'twitter': 'https://twitter.com/lakshmy1988',
      'linkedIn': 'https://www.linkedin.com/in/sreelakshmy-p/',
      'email': 's.lakshmy1988@gmail.com',
      'events': {
        'eventID': 'C24'
      }
    },
    {
      'speakerID': 'S104',
      'speaker': 'Karthik Kalathil',
      'profile': 'CTO and Co-founder at Wattlecorp | Security Consultant | Cybersecurity Product Innovation Manager | Speaker',
      'speakerdesc': 'Mr. Kalathil Karthik is the CTO and Cofounder of Wattlcorp, with more than 9 years of experience in IT, IT security and Networking. Being a cyber security consultant as well, Kathik has also served as a principal advisor for interpreting standards, policies, best practices and designing system security strategy and architecture across multiple IT projects. He has also performed infrastructure and application penetration tests as well as physical security review and social engineering test for global clients. As a leading information security expert and evangelist, Karthik has conducted talks and trainings in various national and international conferences.',
      'thumb': 'assets/images/thumb/Karthik-kalathil.jpg',
      'facebook': 'https://www.facebook.com/kalathil.karthik',
      'twitter': 'https://twitter.com/karthik_k_nair',
      'linkedIn': 'https://www.linkedin.com/in/kalathil-karthik/',
      'email': 'karthik@wattlecorp.com',
      'events': {
        'eventID': 'K24'
      }
    },
    {
      'speakerID': 'S105',
      'speaker': 'Srinivas P',
      'profile': 'Centre Head @ Alamy India',
      'speakerdesc': ' Mr. Srinivas has more than 25 years of experience in IT industry in different countries with extensive experience in project / program management and end to end delivery of IT projects.',
      'thumb': 'assets/images/thumb/Srinivas-p.jpg',
      'facebook': 'https://www.facebook.com/srinivas.paladugu.9',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/srinivas-paladugu-2a68b53/',
      'email': 'SrinivasP@alamy.com',
      'events': {
        'eventID': 'T74'
      }
    },
    {
      'speakerID': 'S106',
      'speaker': 'Suresh Kumar M',
      'profile': 'Sr. Principal Manager – Product Development @ Alamy India',
      'speakerdesc': 'Mr. Suresh has 20 years of professional IT experience in large MNCs like Allianz, Envestnet, Alamy Images and government organization like CDIT, in various techno-managerial roles.',
      'thumb': 'assets/images/thumb/sureshkumar.jpg',
      'facebook': 'https://www.facebook.com/sureshkumar.madhavanpillai',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/suresh-kumar-madhavan-pillai-a027b51a/',
      'email': 'msureshkumars@hotmail.com',
      'events': {
        'event1': 'T74',
        'event2': 'C26'
      }
    },
    {
      'speakerID': 'S107',
      'speaker': 'Jeswin S George',
      'profile': 'Quality Assurance Engineer, Qburst Technologies',
      'speakerdesc': 'Worked as Subject Matter Expert in Device Testing at Amazon Development center, Bangalore. Worked with various pilot projects of Alexa devices from its inception in the industry. Was part of launch programs (Amazon Echo, Echo Show and Echo Spot) of Alexa devices in US, UK, India, Canada and Australia. Was part of the Alexa skill certification team, in order to maintain quality content for Alexa users. Solid understanding of debugging skills as well as Testing concepts and Automating techniques. Currently working as a Quality Assurance Engineer at Qburst Technologies,Technopark, Trivandrum.',
      'thumb': 'assets/images/thumb/jeswin.jpg',
      'facebook': 'https://www.facebook.com/jeswin.manjinikara',
      'twitter': 'https://twitter.com/being_jeswin',
      'linkedIn': 'https://www.linkedin.com/in/jeswin-s-george-a6489192/',
      'email': 'jeswinsgeorge@gmail.com',
      'events': {
        'eventID': 'C25'
      }
    },
    {
      'speakerID': 'S108',
      'speaker': 'Cipson Thomas',
      'profile': 'Agile & Kanban Coach, Trainer & Consultant',
      'speakerdesc': 'Being an Agile coach and Training Professional, Mr. Cipson has mentored, coached and transformed programs and projects into Agile for over a decade. With over 16 years worth of experience in the IT industry, he has also built high performing diverse and distributed Agile teams and is a hands-on, performance-driven servant leader.',
      'thumb': 'assets/images/thumb/cipson.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/cipson/',
      'email': 'cipson@gmail.com',
      'events': {
        'eventID': 'T75'
      }
    },
    {
      'speakerID': 'S109',
      'speaker': 'Sijil Salim',
      'profile': 'Lead Engineer, IBS',
      'speakerdesc': 'Lead engineer at IBS with a rich experience in automation and voice based technologies. Aimed at bringing innovative use of voice based technologies to different niches, has developed varied solutions including a voice controlled solution for Selenium. Holder of a patent in developing a novel and cost-effective solution for railway level-crossing management.',
      'thumb': 'assets/images/thumb/sijil.jpg',
      'facebook': 'https://www.facebook.com/sijil.salim',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sijil-s-3b90b440/',
      'email': 'sijils@gmail.com',
      'events': {
        'eventID': 'T76'
      }
    },
    {
      'speakerID': 'S110',
      'speaker': 'Akshai M',
      'profile': 'Senior Research Fellow, ICFOSS',
      'speakerdesc': 'Applied Researcher and Embedded Device Engineer with hands-on experience in prototyping Low Power Wireless Embedded Hardware and Hardware Design optimization for Small to Medium scale manufacturing. Akshai M started his career with Kerala Startup Mission where he worked as a Technology Innovation Fellow to create COW Mesh (Community Owned Wireless Mesh) and initiated ExpEYES Project for Schools in Kerala, a project which is now part of KITE, formerly known as IT@School. He then joined FOSSEE, IIT Bombay as a Researcher to create Embedded Hardware to implement IEC61499 based distributed control systems for applications in MSME and as training equipment for Engineering colleges. He later joined ICFOSS and is part of it since 2017. He is currently engaged as a Senior Researcher for LoRaWAN CoE, RISC V CoE and OpenFPGA CoE.',
      'thumb': 'assets/images/thumb/akshai.jpg',
      'facebook': 'https://www.facebook.com/akshai.m.ettadayil',
      'twitter': 'https://twitter.com/m_akshai',
      'linkedIn': 'https://www.linkedin.com/in/akshaim/',
      'email': 'akshai.m@icfoss.in',
      'events': {
        'eventID': 'T77'
      }
    },
    {
      'speakerID': 'S112',
      'speaker': 'Jubin Jose',
      'profile': 'Senior NLP engineer, Cedex Technologies',
      'speakerdesc': 'With more than three years worth of industrial experience in ML and NLP, Mr. Jubin Jose is currently working as a senior NLP engineer at Cedex Technologies. He is also a FLOSS enthusiast with a Keen interest in experimenting with crazy ideas and writing about them. He is also a member of Amma, an organization dedicated to collaborating in projects related to machine learning.',
      'thumb': 'assets/images/thumb/jubin.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/jubin-jose-dev/',
      'email': 'hello@josejub.in',
      'events': {
        'eventID': 'C27'
      }
    },
    {
      'speakerID': 'S113',
      'speaker': 'Amar C.P',
      'profile': 'Co-founder & CTO , VinamSolutions Pvt Ltd & Luvia Global Marketing Agency',
      'speakerdesc': 'Mr. Amar C.P is the Co-founder and CTO of VinamSolutions Pvt Ltd & Luvia Global Marketing Agency. With immense experience in Object Oriented Programming(OOP), Symfony Framework, Linux, PHP7, MySQL, Elasticsearch and many others, he has also worked on projects involving the application of Sphinx,Apache, Kafka, Rabbitmq, Shell Scripting, Postfix, Logstash, Kibana, Rest APIs and DNS.',
      'thumb': 'assets/images/thumb/amar.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/amarcp/',
      'email': 'amar@vinam.in',
      'events': {
        'eventID': 'K25'
      }
    },
    {
      'speakerID': 'S114',
      'speaker': 'Biju K Nair',
      'profile': 'Independent Lawyer, Consultant with Open Invention Network and License on Transfer Network',
      'speakerdesc': 'A lawyer with 16 experience, Mr. Biju K Nair is an Independent lawyer as well as a consultant with Open Invention Network (OIN) and License on Transfer Network (LOT Network) both communities being Defensive Patent Strategy. He has in the past worked with the largest law firms in India at their New Delhi Office. He has been a litigation lawyer involved in Constitutional matters, Intellectual Property law, Information Technology, and Commercial Litigation.<br>He has also been involved in various transactions for Corporates and start-ups advising and involved in licensing technology and software, Open Source Compliance, etc.',
      'thumb': 'assets/images/thumb/biju.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/biju-k-nair-0499468/',
      'email': 'bijuailian@gmail.com',
      'events': {
        'eventID': 'C29'
      }
    },
    {
      'speakerID': 'S115',
      'speaker': 'Arun Sasi',
      'profile': 'Joomla Template developer & Lead designer, IBS Software',
      'speakerdesc': 'Arun is a Joomla Template Developer with more than 13 years of industry and domain experience. Working as Lead Designer in IBS Software for the past 9 Years, He is an active member of the Joomla volunteering community. He takes great interest in social and humanitarian activities. He is also part of many cultural initiatives and events happening in and around Technopark.',
      'thumb': 'assets/images/thumb/arun-sasi.jpg',
      'facebook': 'https://www.facebook.com/arunayr',
      'twitter': 'https://twitter.com/geekzazi',
      'linkedIn': 'https://www.linkedin.com/in/arunayr/',
      'email': 'arunayr@gmail.com',
      'events': {
        'eventID': 'K27'
      }
    },
    {
      'speakerID': 'S116',
      'speaker': 'Samuel',
      'profile': 'Cofounder of MistEO',
      'speakerdesc': 'Samuel is the cofounder of MistEO - a computational sustainability company working in the domain of Extreme Weather. Samuel is also the co-founder of SatSure, a satellite data analytics startup based in Bangalore and Statlogic, an AgriIOT company based in Trivandrum and Dubai. Samuel holds a Masters Degrees in Conflict Resolution and Communication Research and is an alumni of Mar Ivanious College in Trivandrum. He is also a Partner of the Kerala Space Park, A Government of Kerala Initiative promoting Space Tech companies to work out of our state.',
      'thumb': 'assets/images/thumb/samuel.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': '',
      'email': 'samuel@misteo.co',
      'events': {
        'eventID': 'T79'
      }
    },
    {
      'speakerID': 'S117',
      'speaker': 'Liji Thomas',
      'profile': 'Technical Manager, Valorem Reply',
      'speakerdesc': 'Liji Thomas is a Technical Manager for Valorem Reply with over a decade of industry experience in technical and leadership roles. She leads a team focused on transforming the digital experiences for a global clientele by creating state-of-the-art solutions, from modern web applications to AI-driven chatbots.',
      'thumb': 'assets/images/thumb/liji-thomas.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/liji-thomas/',
      'email': 'lthomas@valorem.com',
      'events': {
        'eventID': 'C30'
      }
    },
    {
      'speakerID': 'S118',
      'speaker': 'Shahul E S',
      'profile': 'Co-founder at alrt.ai',
      'speakerdesc': 'Currently the Co-Founder & Chief Data Scientist at alrt.ai, Shahul is a Data Science and Machine learning enthusiast, with hands-on experience in Data Analytics, Data Science, Machine learning, Deep learning, and Natural language processing. He is the one and only Kaggle Master from the state of Kerala and is ranked in the top 25 among its 100k+ Kaggle users.<br>https://shahules786.github.io/.',
      'thumb': 'assets/images/thumb/shahul.jpg',
      'facebook': 'https://www.facebook.com/Shahules786',
      'twitter': 'https://twitter.com/Shahules786',
      'linkedIn': 'https://www.linkedin.com/in/shahules/',
      'email': 'shahules786@gmail.com',
      'events': {
        'eventID': 'C31'
      }
    },
    {
      'speakerID': 'S119',
      'speaker': 'Vinesh S',
      'profile': 'Senior Frontend Engineer, QBurst',
      'speakerdesc': 'About 6 years of experience in the IT field, Vinesh started his career as a PHP Developer but gradually fell in love with JavaScript and started exploring it and it\'s frameworks and libraries. He has hands-on experience in frameworks like Angular, React with a better understanding of core JavaScript and it\'s peculiar concepts. He is continuously interested in learning new upcoming technologies and also share it with the other technology aspirants. He loves discussing how one can write better code.',
      'thumb': 'assets/images/thumb/vinesh.jpg',
      'facebook': 'https://www.facebook.com/vinesh.s.7771',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/s-vinesh-10139572/',
      'email': 'svinesh3691@gmail.com',
      'events': {
        'eventID': 'T81'
      }
    },
    {
      'speakerID': 'S120',
      'speaker': 'Robin Tommy',
      'profile': 'Incubation Lab Head, Tata Consultancy Services',
      'speakerdesc': 'Mr. Robin Tommy has been involved in as a Social Innovator, Incubation Consultant, Researcher, Startup Mentor, and Emerging Tech Stack adviser. He has been ranked # 21 amongst Top 100 thought leaders and influencers for 2020 by the Thinkers360 platform. He has filed 45 patents with 7 grants and published more than 25 research papers in IEEE, Springer, and ACM. He is also instrumental in creating IP based researched products and platforms for customers in the emerging technology business. He has been involved in various social innovations research for the differently-abled society. He has won the TATA Innovista 2018 award for the project contributions in social innovation. His team has won the TMA (Trivandrum Management Association) Disruptive CSR Award 2018, KMA (Kerala Management Association) CSR Award 2018, KMA CSR AWARD 2019. His team also won the TCS Innovista 2017, 2018 and 2019 awards. The Rotary International CSR gold Award, 2019 was awarded to Robin Tommy and his team.',
      'thumb': 'assets/images/thumb/Robin-Tommy.jpg',
      'facebook': 'https://www.facebook.com/robin.tommy',
      'twitter': 'https://twitter.com/robintomy',
      'linkedIn': 'https://www.linkedin.com/in/robintommy/',
      'email': '',
      'events': {
        'eventID': 'T82'
      }
    },
    {
      'speakerID': 'S121',
      'speaker': 'Vinod Narayan',
      'profile': 'Agile Coach | SAFe® SPC | Educator, Founder, Penpositive Inc.',
      'speakerdesc': 'Agile Coach and Digital Transformation Lead with over 25 years in Technology Management, as a consultant, Entrepreneur, and Servant Leader facilitating Engineering & Product teams in their journey of agile delivery.<br>As a Poet, Blogger, Podcaster, and independent filmmaker he has made his presence felt strongly in all these domains. And he wants the same for others. Also a Video Podcaster under the alias Ballatha Pahayan (ബല്ലാത്ത പഹയൻ) on YouTube.',
      'thumb': 'assets/images/thumb/Vinod-Narayan.jpg',
      'facebook': 'https://www.facebook.com/pahayanmedia/',
      'twitter': 'https://twitter.com/vinodnarayan',
      'linkedIn': 'https://www.linkedin.com/in/vinodn/',
      'email': '',
      'events': {
        'eventID': 'T85'
      }
    },
    {
      'speakerID': 'S124',
      'speaker': 'Nikhil Chandran',
      'profile': 'Founder & Ceo - Tiltlabs ',
      'speakerdesc': 'Metaverse & Web 3.0 Strategist | Virtual Production | Games',
      'thumb': 'assets/images/thumb/Nikhil_Chandran.jpg',
      'facebook': 'https://www.facebook.com/nikhilchandran.n',
      'twitter': 'https://twitter.com/nikhilchandran_',
      'linkedIn': 'https://www.linkedin.com/in/nikhil-tiltlabs/',
      'email': '',
      'events': {
        'eventID': 'T87'
      }
    },
    {
      'speakerID': 'S125',
      'speaker': 'Joel Zachariah',
      'profile': 'Creative Director - Tiltlabs ',
      'speakerdesc': 'Narative Designer, Independent Developer, World Builder.',
      'thumb': 'assets/images/thumb/Joel-Zachariah.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/joel-zachariah-531b1a11a/',
      'email': '',
      'events': {
        'eventID': 'T88'
      }
    },
    {
      'speakerID': 'S2',
      'speaker': 'Madhusudan Shekar',
      'profile': 'Chief Evangelist of Amazon Web Services, Amazon India',
      'speakerdesc': 'Technology leader with a rich experience in transforming traditional IT into a modern real-time responsive service, Mr. Madhusudan Shekar is the Chief Evangelist of Amazon Web Services, Amazon India. Armed with an excellent understanding of incorporating Cloud, Mobility and Analytics into Amazon for real-time business and enabling new formats of collaboration within employees and with customers, his past clients and engagements include Deutsche Telekom, IDEA Cellular, Belgacom, DirecTV, HP, AMP Financial Services, News Corp, Societe-Generale, , Avaya, Matsushita, Tata-Sky and Tata Motors.',
      'thumb': 'assets/images/thumb/Madhusudan-Shekar.jpg',
      'facebook': 'https://www.facebook.com/MadhusudanShekar',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/madhusudanshekar/',
      'email': '',
      'events': {
        'event1': 'T56'
      }
    },
    {
      'speakerID': 'S3',
      'speaker': 'Janeesh Uthuppan',
      'profile': 'digital marketing professional and the Founding Partner of Webdura Technologies',
      'speakerdesc': 'Janeesh Uthuppan is a highly rated digital marketing professional and the Founding Partner of Webdura Technologies, one of Kerala’s most impactful Digital Marketing agencies with expertise in Search Engine Optimization, Pay per Click Advertising and Online Marketing Campaigns. Janeesh has over seven years of Digital Marketing experience in helping businesses use the power of the web to drive sales and gain visibility. Prior to his career in Digital Marketing, he was part of Kerala’s leading news daily, the Mathrubhumi group',
      'thumb': 'assets/images/thumb/Janeesh-Uthuppan.jpg',
      'facebook': 'https://www.facebook.com/janeeshuthupp',
      'twitter': 'https://twitter.com/janeeshuthupp',
      'linkedIn': 'https://www.linkedin.com/in/janeeshuthupp/',
      'email': '',
      'events': {
        'event1': 'T55',
        'event2': 'C3',
        'event3': 'K4'
      }
    },
    {
      'speakerID': 'S4',
      'speaker': 'Rakesh B S',
      'profile': 'Co-Founders of Qucentis & BIGOrg',
      'speakerdesc': 'Qucentis is a software company building a Blockchain based Asset Management System. BIGOrg is an open collective of technologists, companies & hobbyists interested in Blockchain. BIGOrg conducts meetups every month on third Thursdays and hosts an active Telegram group.',
      'thumb': 'assets/images/thumb/Rakesh-B-S.jpg',
      'facebook': 'https://www.facebook.com/rakeshbs',
      'twitter': 'https://twitter.com/rakesh_bs',
      'linkedIn': 'https://www.linkedin.com/in/rakesh-bs-78732817/',
      'email': '',
      'events': {
        'event1': 'T54',
        'event2': 'K1'
      }
    },
    {
      'speakerID': 'S5',
      'speaker': 'Jikku Jose',
      'profile': 'Ruby developer running a small startup by the name Qucentis in Kerala Startup Mission',
      'speakerdesc': 'Jikku Jose is a Ruby developer running a small startup by the name Qucentis in Kerala Startup Mission. Now working on building a framework for rapid prototyping of apps using Ruby.',
      'thumb': 'assets/images/thumb/Jikku-Jose.jpg',
      'facebook': 'https://www.facebook.com/JikkuJose',
      'twitter': 'https://twitter.com/jikkujose?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/jikkujose/',
      'email': '',
      'events': {
        'event1': 'T54',
        'event2': 'T31',
        'event3': 'K1'
      }
    },
    {
      'speakerID': 'S6',
      'speaker': 'Krishnakumar S',
      'profile': 'Senior Consultant-Database Administration at EnvestNet Trivandrum',
      'speakerdesc': 'Senior Consultant-Database Administration at EnvestNet Trivandrum, Krishnakumar designs various Database Projects and works closely with development teams, improving and scaling Data Intensive Applications. With around 15 years of experience in software, he has worked extensively on various Database Projects designing scalable Database Systems, Performance Optimizations,Upgrades and Migrations. He is also an active participant in various technical forums and a proponent of Free Knowledge Sharing.',
      'thumb': 'assets/images/thumb/Krishnakumar-S.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/krishnakumars1/',
      'email': '',
      'events': {
        'event1': 'T53'
      }
    },
    {
      'speakerID': 'S7',
      'speaker': 'Jeswin Simon',
      'profile': 'Senior Engineer - Product, Envestnet',
      'speakerdesc': 'Jeswin Simon, Senior Engineer - Product, Envestnet is a web and mobile developer who has previously developed applications for Blackberry 10 and Windows Phone 7. Passionate about hardware and tinkering, Jeswin was a speaker at TEDxCoimbatore during his student days.',
      'thumb': 'assets/images/thumb/Jeswin-Simon.jpg',
      'facebook': 'https://www.facebook.com/jeswinsimon',
      'twitter': 'https://twitter.com/jeswinsimon',
      'linkedIn': 'http://in.linkedin.com/pub/jeswin-simon/20/405/184',
      'email': '',
      'events': {
        'event1': 'T52'
      }
    },
    {
      'speakerID': 'S8',
      'speaker': 'Jaydev S V',
      'profile': 'Founder of volvox',
      'speakerdesc': 'Jaydev, Co-founder, Volvox, is a risk analyst by trade. Responsible for engineering risk assessment, he currently works on implementation and overseeing underwriting macro-scale insurance programs. He spends his spare time studying up on everything that the different potential future timelines entail and identifies as a performing philosopher.',
      'thumb': 'assets/images/thumb/Jaydev-S-V.jpg',
      'facebook': 'https://www.facebook.com/jaydev93',
      'twitter': '',
      'linkedIn': '',
      'email': '',
      'events': {
        'event1': 'T51'
      }
    },
    {
      'speakerID': 'S9',
      'speaker': 'Hrishi Olickel',
      'profile': 'Founder of volvox',
      'speakerdesc': 'Hrishi, Co-founder, Volvox, has done VR and Robotics work with National Geographic and FLIR Inc., Machine Learning and Blockchain Development with Anquan Capital (Fintech VC Firm in Singapore) and Dinardirham ($500 million company based in Malaysia). He has also dabbled in Genetic Algorithm based Process Automation and Game Theoretic analysis.',
      'thumb': 'assets/images/thumb/Hrishi-Olickel.jpg',
      'facebook': 'https://www.facebook.com/hrishioa',
      'twitter': 'https://twitter.com/hrishioa',
      'linkedIn': 'https://www.linkedin.com/in/hrishioa/',
      'email': '',
      'events': {
        'event1': 'T51'
      }
    },
    {
      'speakerID': 'S10',
      'speaker': 'Manuyash Chaudhary',
      'profile': 'AI & NLP Developer & Researcher, Accubits Technologies',
      'speakerdesc': 'Manuyash Chaudhary, AI & NLP Developer & Researcher, Accubits Technologies is an MS in Machine Learning & Artificial Intelligence from University College London. He has been instrumental for path-breaking research on Data Science and its implementation during his career. He is responsible for developing AI technologies and solving machine learning problems for clients at Accubits. He works in Python and R, on platforms like Tensorflow, H2O.ai and tools like SPSS, WEKA and Tableau.',
      'thumb': 'assets/images/thumb/manuyash-chaudhary.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': '',
      'email': '',
      'events': {
        'event1': 'T49',
        'event2': 'K6',
        'event3': 'C1'
      }
    },
    {
      'speakerID': 'S11',
      'speaker': 'Suchit Majumdar',
      'profile': 'Chief Data Science Evangelist, UpX Academy, Hyderabad',
      'speakerdesc': 'Suchit Majumdar, Chief Data Science Evangelist, UpX Academy, is a Machine Learning & IoT expert, and has been instrumental in setting up Big Data Analytics practices for the AP government’s Smart Cities mission. He assists top management in using advanced analytics to build core strategies around data. Currently, he is heading the products division at UpX Academy and helps companies and professionals realize the value of advance technologies in the growth of business and personal lives.',
      'thumb': 'assets/images/thumb/Suchit-Majumdar.jpg',
      'facebook': 'https://www.facebook.com/suchit.majumdar.5',
      'twitter': 'https://twitter.com/suchitmajumdar',
      'linkedIn': 'https://www.linkedin.com/in/suchitmajumdar/',
      'email': 'suchit@upxacademy.com',
      'events': {
        'event1': 'T48'
      }
    },
    {
      'speakerID': 'S12',
      'speaker': 'Amal Dev',
      'profile': 'Technical Analyst, UST Global',
      'speakerdesc': 'Amal Dev, Technical Analyst, UST Global, is a full stack web developer with over 10 years of experience focusing on Microsoft Technologies. Being a passionate developer of web and desktop applications, he is currently involved in delivering applications for the enterprises which includes Fortune 500 companies. He won the Microsoft MVP Award in 2016 for his exceptional contribution to the development community. He is also an active blogger who regularly writes about technologies such as ASP.NET Core, Docker, ASP.NET MVC and many more.',
      'thumb': 'assets/images/thumb/Amal-Dev.jpg',
      'facebook': 'https://www.facebook.com/amaldevv',
      'twitter': 'https://twitter.com/amaldevv',
      'linkedIn': 'https://www.linkedin.com/in/amaldevv/',
      'email': 'amaldevv@gmail.com',
      'events': {
        'event1': 'T47',
        'event2': 'K5'
      }
    },
    {
      'speakerID': 'S13',
      'speaker': 'Shine Xavier',
      'profile': 'Senior Architect, UST Global',
      'speakerdesc': 'Shine Xavier, Senior Architect, UST Global, is a core software engineering practitioner with extreme passion for designing/building software solutions, application frameworks and accelerators that helps maintain productivity and quality. His areas of interest include Functional Programming, Interpreters, JavaScript Library Development, Visual Programming, Algorithms, Enterprise Mobility, IoT and Machine Learning. Besides being the author of YieldJS and SlangJS, he is also the co-author of the book titled “.NET Design Patterns” by PACKT publishing.',
      'thumb': 'assets/images/thumb/Shine-Xavier.jpg',
      'facebook': 'https://www.facebook.com/shine.xavier.98',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/shinexavier/',
      'email': 'shine.xavier@ust-global.com',
      'events': {
        'event1': 'T46'
      }
    },
    {
      'speakerID': 'S14',
      'speaker': 'Amal Shehu',
      'profile': 'JS Frontend Engineers, FAYA Innovations',
      'speakerdesc': 'Amal Shehu, Software Developer, Neoitobis a Python developer who got introduced to TypeScript/Angular ecosystem by chance. Currently he is a full-time Angular developer who is keen on optimizing workflow and exploring deeper into technology.',
      'thumb': 'assets/images/thumb/Amal-Shehu.jpg',
      'facebook': 'https://www.facebook.com/amalshehu',
      'twitter': 'https://twitter.com/amal_shehu',
      'linkedIn': 'https://www.linkedin.com/in/amal-shehu-639824104/',
      'email': 'amalshehu@gmail.com',
      'events': {
        'event1': 'T45',
        'event2': 'C4',
        'event3': 'K2',
        'event4': 'T72'
      }
    },
    {
      'speakerID': 'S15',
      'speaker': 'Vijay Kumar M',
      'profile': 'CEO & MD – Webyfy Infotech Pvt Ltd',
      'speakerdesc': 'Vijay Kumar M, CEO & MD – Webyfy Infotech Pvt Ltd. has a multi-faceted career handling different roles like Vice President – International Marketing, Nest Group, Vice President - Operations Suntec Business Solutions, Director & CIO GE Power Controls India and many more. He is passionate about IOT and has developed many technology products in that realm. His other areas of interest include Business Intelligence, Product Management, Cloud Computing, Testing, etc. He has published several papers and has compiled several books on technology, maintenance and development.',
      'thumb': 'assets/images/thumb/Vijay-Kumar-M.jpg',
      'facebook': 'https://www.facebook.com/ReachVKM',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/vijay-kumar-m-04818b/',
      'email': 'vijay@webyfy.com',
      'events': {
        'event1': 'T44'
      }
    },
    {
      'speakerID': 'S16',
      'speaker': 'Anand Ramkumar',
      'profile': 'Senior Test Engineer, Experion Technologies, Trivandrum',
      'speakerdesc': 'Anand Ramkumar from Experion Technologies, Trivandrum is a Senior Test Engineer with over 7 years of experience in various verticals of Testing. He is an ISTQB certified technology enthusiast passionate about Programming, Performance Testing, creating Automation Framework and setting up of Test Environments.',
      'thumb': 'assets/images/thumb/Anand-Ramkumar.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': '',
      'email': 'anand.ramkumar@experionglobal.com',
      'events': {
        'event1': 'T43',
        'event2': 'T60'
      }
    },
    {
      'speakerID': 'S17',
      'speaker': 'Sarath Varma Asokan',
      'profile': 'Senior Consultant (Software Testing), Se-Mentor, Trivandrum.',
      'speakerdesc': 'Sarath Varma Asokan from Se-Mentor, Trivandrum is a Senior Consultant (Software Testing) with over 11 years of experience in different Software Engineering areas like Testing, Requirement Management and implementing Manual & Automated Software Testing. He is an IBM Certified Specialist for Rational Test Management and Robot. He is well experienced in Testing Methodologies, Creation of test cases, writing test scripts and in use of Automation tools. Besides being a Consultant, he is also a Trainer on testing tools like IBM Rational Functional Tester, Rational Test Manager, Rational Manual Tester, Rational Robot, HP UFT, HP Quality Center, HP ALM, Microsoft Test Manager etc.',
      'thumb': 'assets/images/thumb/Sarath-Varma-Asokan.jpg',
      'facebook': 'https://www.facebook.com/sarath.varma.180',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sarath-varma-88441811/',
      'email': 'sarath@se-mentor.com',
      'events': {
        'event1': 'T42'
      }
    },
    {
      'speakerID': 'S18',
      'speaker': 'Praseed Pai',
      'profile': 'software architect working in UST Global',
      'speakerdesc': 'Praseed Pai is a well-known Software Architect working in UST Global. His areas of interest include Enterprise Software Development (using C#/.net/Java), Engineering Software Development (CAD/CAM/C++), Cross Platform C++ Development (Windows/Linux/Mac), Computer Graphics, Computational Finance and Domain specific Programming Languages. He is the author of SLANG open source compiler infrastructure for learning about compilers. Currently, he is co-authoring a book for Packt Publishing on .NET Design Patterns. He has led 200+ presentations on various technology topics.',
      'thumb': 'assets/images/thumb/Praseed-Pai.jpg',
      'facebook': 'https://www.facebook.com/praseedpai.kt',
      'twitter': 'https://twitter.com/praseed3point14?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/praseed-pai-k-t-369ba225/',
      'email': 'PraseedPai.ThrivikramaPai@ust-global.com',
      'events': {
        'event1': 'T41',
        'event2': 'T38'
      }
    },
    {
      'speakerID': 'S19',
      'speaker': 'Deepak Varma',
      'profile': 'Director, Technospirit Consulting, Cochin',
      'speakerdesc': 'Deepak Varma is the Director, Technospirit Consulting, Cochin. He has over 20 years of experience in Strategic Marketing, Operations Management & Sales with global and Indian companies. He is also an expert in Cloud, Mobility and Big Data. He has worked in the SME segment over the last years with clients like MOPlay, Smart Cousins, Springboards. He is a passionate soft skills trainer and is a proven technical business person. He has experience in verticals of healthcare, government, automotive and telecom sectors in IT services/ products.The session will be led by Mr. Deepak Varma, Director, Technospirit Consulting, Cochin. Mr. Deepak has over 20 years of experience in Strategic Marketing, Operations Management & Sales with Global and Indian companies. He is also an expert in Cloud, Mobility and Big Data. He has worked in the SME segment over the last years with clients like MOPlay, Smart Cousins, Springboards. He is a passionate soft skills trainer and is a proven technical business person. He has experience in verticals of healthcare, government, automotive and telecom sectors in IT services/ products.Deepak Varma is the Director, Technospirit Consulting, Cochin. He has over 20 years of experience in Strategic Marketing, Operations Management & Sales with global and Indian companies. He is also an expert in Cloud, Mobility and Big Data. He has worked in the SME segment over the last years with clients like MOPlay, Smart Cousins, Springboards. He is a passionate soft skills trainer and is a proven technical business person. He has experience in verticals of healthcare, government, automotive and telecom sectors in IT services/ products.',
      'thumb': 'assets/images/thumb/Deepak-Varma.jpg',
      'facebook': 'https://www.facebook.com/deepak.varma.792',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/deepak-varma/',
      'email': 'deepak@technospirit.in, hellodeepak@hotmail.com',
      'events': {
        'event1': 'T40'
      }
    },
    {
      'speakerID': 'S20',
      'speaker': 'Nikhil Krishna',
      'profile': 'Solutions Architect working in UST Global',
      'speakerdesc': 'Nikhil Krishna is a Solutions Architect working in UST Global with over 16 years of experience in IT Consulting and Product Development. His areas of interest include Reactive and Distributed Systems, Programming Languages, and Bitcoin. He is passionate about programming for the web and its potential as a tool to transform user experience. His career spans across diverse roles from Dev Ops to Developer to Quality Assurance to Product Owner.',
      'thumb': 'assets/images/thumb/Nikhil-Krishna.jpg',
      'facebook': 'Nikhil.Krishna@ust-global.com',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/nikhilkrishna/',
      'email': '',
      'events': {
        'event1': 'T39',
        'event2': 'T73'
      }
    },
    {
      'speakerID': 'S21',
      'speaker': 'Sarath C',
      'profile': 'Architect at Experion Technologies, Technopark, Trivandrum',
      'speakerdesc': 'Sarath has more than a decade of experience in designing and developing systems across various domains and platforms. He’s presently working as a Software Architect, leading mobile development at Experion Technologies. At Experion, he focuses on Product Engineering, Technical Consultation and administers mobile development practices focusing on iOS and Android Platforms. He has more than a decade of industry experience and has successfully delivered products across various technologies and domains.',
      'thumb': 'assets/images/thumb/Sarath-C.jpg',
      'facebook': 'https://www.facebook.com/csarath',
      'twitter': 'https://twitter.com/sarat?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/sarathc/',
      'email': 'csarath@gmail.com',
      'events': {
        'event1': 'T37',
        'event2': 'T23'
      }
    },
    {
      'speakerID': 'S22',
      'speaker': 'Priya Sivakumar',
      'profile': 'Delivery Head, TATA Elxsi',
      'speakerdesc': 'Priya Sivakumar has been with TATA Elxsi for the past 10 years and is currently the Delivery Head in the Broadcast Business Unit. She handles the customer account for a leading US Cable Service Provider. She graduated from the College of Engineering, Trivandrum (CET) in 1998, and started her career with the Embedded Group in Philips Software Centre, Bangalore, before joining TATA Elxsi. In her current role, she led the team through a transition from Waterfall, to Agile to DevOps. Today, the team is working seamlessly with the customer in a mature DevOps environment and reaps the benefits of the transition.',
      'thumb': 'assets/images/thumb/Priya-Sivakumar.jpg',
      'facebook': 'https://www.facebook.com/priya.sivakumar.31508',
      'twitter': '',
      'linkedIn': '',
      'email': 'priyaskumar@tataelxsi.co.in',
      'events': {
        'event1': 'T36'
      }
    },
    {
      'speakerID': 'S23',
      'speaker': 'Vijay Dev',
      'profile': 'Lead Front-End Developer of Qburst',
      'speakerdesc': 'Vijay Dev is the Lead Front-End Developer of Qburst. He is a pioneer in front-end development with over 7 years of experience in the filed. He started building javascript MVC applications since 2012, before powerful frameworks like Backbone, Ember, Angular etc became popular and has worked with a few big clients like CustomMade & AOL.',
      'thumb': 'assets/images/thumb/Vijay-Dev.jpg',
      'facebook': 'https://www.facebook.com/iamvijaydev',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/vijaydev/',
      'email': 'vijaydev.in@gmail.com',
      'events': {
        'event1': 'T35',
        'event2': 'T34'
      }
    },
    {
      'speakerID': 'S24',
      'speaker': 'Nikhil Raj R',
      'profile': 'Senior SEO Engineer at Alamy Images India Pvt.Ltd.',
      'speakerdesc': 'Nikhil is a Senior SEO Engineer at Alamy Images, a stock photography agency with a collection of over 65 million images. In this role, he is responsible for improving Alamy\'s presence in Google Image Search. Previously he worked for Suyati Technologies at Infopark and DK New Media, a marketing agency where he consulted some of the biggest brands like Socialcast, Zimbra, Angie\'s List, Mindjet, Formstack, Roche Diagnostics.',
      'thumb': 'assets/images/thumb/Nikhil-Raj-R.jpg',
      'facebook': 'https://www.facebook.com/nikhilrajr',
      'twitter': 'https://twitter.com/nikhilrajr?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/nikhilrajr/',
      'email': 'nikhilrr@alamy.com',
      'events': {
        'event1': 'T33'
      }
    },
    {
      'speakerID': 'S25',
      'speaker': 'Aneesh Sreedharan',
      'profile': 'Chief Exicutive & Technology Enthusiast, 2Hats Logic Solutions, Kochi',
      'speakerdesc': 'Aneesh is a developer turned entrepreneur with around 9 years’ experience in the industry. He started his career as a web developer in Kochi back in 2006 and got a chance to work with some of the best programmers back then. He started developing in Magento from 2008 in its early stages. Almost the same time started with Zend framework. Later he moved to Europe and worked with some talented western European programmers in some heavy traffic websites. Inspired by the Dutch entrepreneurs, he decided to move back to India to start his own company. Thus he founded 2Hats Logic Solutions with a partner in 2014. Currently the company work with Magento, Laravel , AngularJS, Zend framework, CodeIgniter etc.<br>Outside technical life he is a traveller and goes on solo trips across various countries, hosts travellers etc.',
      'thumb': 'assets/images/thumb/Aneesh-Sreedharan.jpg',
      'facebook': 'https://www.facebook.com/aneeshvs',
      'twitter': 'https://twitter.com/aneeshvs',
      'linkedIn': 'https://www.linkedin.com/in/aneeshsreedharan/',
      'email': 'aneevs@gmail.com',
      'events': {
        'event1': 'T32'
      }
    },
    {
      'speakerID': 'S26',
      'speaker': 'Liju Pillai',
      'profile': 'Co-founder & CEO of Perfomatix Solutions Pvt Ltd',
      'speakerdesc': 'Liju Pillai is the Co-founder & CEO of Perfomatix Solutions Pvt. Ltd., with over a decade of experience in the IT industry. Perfomatix is one of the frontrunners of Angular JS in Trivandrum.',
      'thumb': 'assets/images/thumb/Liju-Pillai.jpg',
      'facebook': 'https://www.facebook.com/lijurpillai',
      'twitter': 'https://twitter.com/lijuperfomatix',
      'linkedIn': 'https://www.linkedin.com/in/lijurajpillai/',
      'email': 'liju@perfomatix.com',
      'events': {
        'event1': 'T30',
        'event2': 'T18'
      }
    },
    {
      'speakerID': 'S27',
      'speaker': 'Ashik Ajith',
      'profile': 'Software Engineer, Ruby Software India Pvt.Ltd.',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Ashik-Ajith.jpg',
      'facebook': 'https://www.facebook.com/ashik.ajith.1',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/ashikajith/',
      'email': 'ashikajith@gmail.com',
      'events': {
        'event1': 'T29'
      }
    },
    {
      'speakerID': 'S28',
      'speaker': 'Rajeev J Sebastian',
      'profile': 'CEO, Alokin Software',
      'speakerdesc': 'Rajeev has associated with many successful national and international projects during his 16 years in the industry, including One Rank One Pension, Kerala State Legislative Assembly Knowledge Base, DC Books, Rachana Malayalam Operating System, American Honda Bikes, Toyota Racing Development, AOL Movies and Music, etc. He is a follower and contributor to various open source projects such as KDE, Kubuntu, Pardus Linux, SCIM, Mootools, etc. He also played a leading role in the Malayalam Unicode encoding standards, and development of UIs and fonts for Malayalam. Currently the CEO of Alokin Software, he leads a team of Python and OOP developers and is deeply interested in Software Engineering, OOP, AI, philosophy and films.',
      'thumb': 'assets/images/thumb/Rajeev-J-Sebastian.jpg',
      'facebook': 'https://www.facebook.com/rajeevjsebastian',
      'twitter': 'https://twitter.com/rajeevjsv',
      'linkedIn': 'https://www.linkedin.com/in/rajeev-j-sebastian-290b972/',
      'email': 'rajeev.sebastian@alokin.in',
      'events': {
        'event1': 'T28',
        'event2': 'T58'
      }
    },
    {
      'speakerID': 'S29',
      'speaker': 'Faiz Mohamed Haneef',
      'profile': 'Director - Neoito Technologies Pvt Ltd',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Faiz-Mohamed-Haneef.jpg',
      'facebook': 'https://www.facebook.com/faizmh',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/faizmh/',
      'email': 'faizmh@gmail.com',
      'events': {
        'event1': 'T27',
        'event2': 'T25'
      }
    },
    {
      'speakerID': 'S30',
      'speaker': 'Deepu S Nath',
      'profile': 'Managing Director - Tech Faya Innovations Pvt Ltd',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Deepu-S-Nath.jpg',
      'facebook': 'https://www.facebook.com/deepusnath',
      'twitter': 'https://twitter.com/deepusnath123',
      'linkedIn': 'https://www.linkedin.com/in/deepusnath/',
      'email': 'deepusnath@gmail.com',
      'events': {
        'event1': 'T27',
        'event2': 'T12',
        'event3': 'T7',
        'event4': 'T8',
        'event5': 'T14'
      }
    },
    {
      'speakerID': 'S31',
      'speaker': 'Nithin S',
      'profile': '',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Nithin-S.jpg',
      'facebook': 'ttps://www.facebook.com/nithin.surendran?ref=br_rs',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/nithins/',
      'email': 'nithin1600@gmail.com',
      'events': {
        'event1': 'T27',
        'event2': 'T1',
        'event3': 'T15'
      }
    },
    {
      'speakerID': 'S32',
      'speaker': 'Shiraz Samad',
      'profile': 'Front End Developer at DBG',
      'speakerdesc': 'Shiraz samad is a Front End Developer at DBG, focusing on the intersection between web performance and cutting edge browser interactivity. He\'s an open source advocate who enjoys building tools for the web with third party API\'s and mesmerizing CSS animations.He has 6+ years of experience in developing and implementing clean, semantic & tidy traditional and dynamic websites, mobile sites/Apps.',
      'thumb': 'assets/images/thumb/Shiraz-Samad.jpg',
      'facebook': 'https://www.facebook.com/shiraz.samad',
      'twitter': 'https://twitter.com/shirazz',
      'linkedIn': 'https://www.linkedin.com/in/shirazsamad/',
      'email': 'shirazwaits@gmail.com',
      'events': {
        'event1': 'T27',
        'event2': 'T16',
        'event3': 'T21'
      }
    },
    {
      'speakerID': 'S33',
      'speaker': 'Lakshmikant Deshpande',
      'profile': 'Neoito Technologies',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Lakshmikant-Deshpande.jpg',
      'facebook': 'https://www.facebook.com/friendzheart',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/lakshmikant-deshpane/',
      'email': 'lakshmikant4u@gmail.com',
      'events': {
        'event1': 'T25'
      }
    },
    {
      'speakerID': 'S34',
      'speaker': 'Mohana Kumar',
      'profile': 'Senior Software Developer',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Mohana-Kumar.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': '',
      'email': 'MohanaKumar.Mohan@ust-global.com',
      'events': {
        'event1': 'T24'
      }
    },
    {
      'speakerID': 'S35',
      'speaker': 'Aromal Sasidharan',
      'profile': 'IOS developer at DBG',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Aromal-Sasidharan.jpg',
      'facebook': 'https://www.facebook.com/aromal.sasidharan',
      'twitter': 'https://twitter.com/aromal_anchal/media',
      'linkedIn': 'https://www.linkedin.com/in/aromal-sasidharan-870b4032/',
      'email': 'aromalsasidharan@gmail.com',
      'events': {
        'event1': 'T22',
        'event2': 'T10'
      }
    },
    {
      'speakerID': 'S36',
      'speaker': 'Thahir Maheen',
      'profile': 'IOS developer at DBG',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Thahir-Maheen.jpg',
      'facebook': 'https://www.facebook.com/tthahhir',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/thahir-maheen-554b9548/',
      'email': 'thahirmaheen@icloud.com',
      'events': {
        'event1': 'T22',
        'event2': 'T26'
      }
    },
    {
      'speakerID': 'S37',
      'speaker': 'Adarsh V C',
      'profile': 'IOS developer(Team Lead) at DBG',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Adarsh-V-C.jpg',
      'facebook': '',
      'twitter': 'https://twitter.com/vcadarsh1',
      'linkedIn': 'https://www.linkedin.com/in/adarshvc/',
      'email': 'adarsh@fayausa.com',
      'events': {
        'event1': 'T26',
        'event2': 'T10'
      }
    },
    {
      'speakerID': 'S38',
      'speaker': 'Praveen Vijayan',
      'profile': 'Front-end developer at Flip Media',
      'speakerdesc': 'As a front-end developer, Praveen Vijayan has 8+ years of experience in developing and implementing clean, semantic & tidy traditional and dynamic websites, mobile sites/App, interface designs across a wide range of industry sectors and for leading international brands, using state of the art technologies. He is passionate about art and technology, and also an avid contributor to the open source projects.',
      'thumb': 'assets/images/thumb/Praveen-Vijayan.jpg',
      'facebook': 'https://www.facebook.com/praveenvijayan0',
      'twitter': 'https://twitter.com/praveen_vijaya',
      'linkedIn': 'https://www.linkedin.com/in/pvnair/',
      'email': 'praveenv.vijayan@gmail.com',
      'events': {
        'event1': 'T3',
        'event2': 'T20'
      }
    },
    {
      'speakerID': 'S39',
      'speaker': 'Dr. Jayaraj Poroor',
      'profile': 'Founder of DependSoft Consulting',
      'speakerdesc': 'Dr.Jayaraj Poroor is the founder of DependSoft Consulting. With 19+ years of industry/R&D experience in cloud, web, mobile, and embedded settings, he is a hands-on, versatile technologist with a passion for information security. His security research papers have appeared in leading international journals such as the IEEE Internet Computing. He is the author of one of the earliest open source SSL VPNs.',
      'thumb': 'assets/images/thumb/Dr-Jayaraj-Poroor.jpg',
      'facebook': 'https://www.facebook.com/jayaraj.poroor',
      'twitter': 'https://twitter.com/jayarajporoor',
      'linkedIn': 'https://www.linkedin.com/in/jayarajporoor/',
      'email': 'jayaraj@dependsoft.com',
      'events': {
        'event1': 'T19'
      }
    },
    {
      'speakerID': 'S40',
      'speaker': 'Shameer B',
      'profile': 'UI Lead at FAYA',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Shameer-B.jpg',
      'facebook': 'https://www.facebook.com/shameer.badarudeen.9',
      'twitter': 'https://twitter.com/sham_4u',
      'linkedIn': 'https://www.linkedin.com/in/shameerbadarudeen/',
      'email': 'bshameer@gmail.com',
      'events': {
        'event1': 'T17',
        'event2': 'T16'
      }
    },
    {
      'speakerID': 'S41',
      'speaker': 'Rahul Raj',
      'profile': 'UX Lead at FAYA',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Rahul-Raj.jpg',
      'facebook': 'https://www.facebook.com/rahul.raj.94064',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/rahul-raj-sr-15a42030/',
      'email': 'rahulrajessar@gmail.com',
      'events': {
        'event1': 'T17',
        'event2': 'T16'
      }
    },
    {
      'speakerID': 'S42',
      'speaker': 'Sumil K S',
      'profile': 'UI Developer at FAYA',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Sumil-K-S.jpg',
      'facebook': 'https://www.facebook.com/sumilpoovar.sumil',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sumilks/',
      'email': 'sumilpoovar@gmail',
      'events': {
        'event1': 'T17'
      }
    },
    {
      'speakerID': 'S43',
      'speaker': 'Ganesh Kumar G',
      'profile': 'Senior UI Developer at McFadyen Digital',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Ganesh-Kumar-G.jpg',
      'facebook': 'https://www.facebook.com/ganeshkg007',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/ganeshkumargopinathan/',
      'email': 'ganeshkg007@gmail.com',
      'events': {
        'event1': 'T16'
      }
    },
    {
      'speakerID': 'S44',
      'speaker': 'Haneefa T P',
      'profile': 'Developer at FAYA',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Haneefa-T-P.jpg',
      'facebook': 'https://www.facebook.com/haneef.abdulla',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/haneefa/',
      'email': 'hanetp@gmail.com',
      'events': {
        'event1': 'T15',
        'event2': 'T2'
      }
    },
    {
      'speakerID': 'S45',
      'speaker': 'Sreenath Sasikumar',
      'profile': 'Developer at FAYA',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Sreenath-Sasikumar.jpg',
      'facebook': 'https://www.facebook.com/sreenath.sasikumar.33',
      'twitter': 'https://twitter.com/sreenath_s',
      'linkedIn': 'https://www.linkedin.com/in/sreenathsasikumar/',
      'email': 'sreenath.sasikumar@gmail.com',
      'events': {
        'event1': 'C7',
        'event2': 'T15',
        'event3': 'T2',
        'event4': 'C15'
      }
    },
    {
      'speakerID': 'S46',
      'speaker': 'Suresh Babu',
      'profile': 'Firmusoft Pvt. Ltd',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Suresh-Babu.jpg',
      'facebook': 'https://www.facebook.com/sureshbabupuzhakkal',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/suresh-babu-9b764a18/',
      'email': 'suresh.babu@firmusoft.co.in',
      'events': {
        'event1': 'T13'
      }
    },
    {
      'speakerID': 'S47',
      'speaker': 'Rejah Rehim',
      'profile': 'FAYA',
      'speakerdesc': 'Rejah Rehim is currently a security architect with FAYA Innovations and is a long-time preacher of open source and has authored a book titled, Effective Python Penetration Testing. A steady contributor to the Mozilla Foundation, he has to his credit eight Mozilla add-ons, including the highly successful Clear Console add-on which was selected as one of the best Mozilla add-ons of 2013. With a user base of more than 44,000, it has registered more than 6,50,000 downloads till date. He has successfully created the world\'s first one-of-a-kind security testing browser bundle, PenQ. Rejah is also an active member of the OWASP and a chapter leader of OWASP Kerala. Besides being a part of the Cyber Security division of FAYA, Rejah is also a fan of process automation and has implemented it at FAYA.',
      'thumb': 'assets/images/thumb/Rejah-Rehim.jpg',
      'facebook': 'https://www.facebook.com/rejah.rehim',
      'twitter': 'https://twitter.com/rejah_rehim?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/rejah/',
      'email': 'rejah.rehim@gmail.com',
      'events': {
        'event1': 'K3',
        'event2': 'T11',
        'event3': 'T6',
        'event4': 'T5',
        'event5': 'T4',
        'eventID': 'K14'
      }
    },
    {
      'speakerID': 'S48',
      'speaker': 'Rahul Krishnan',
      'profile': 'Attinad Software',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Rahul-Krishnan.jpg',
      'facebook': 'https://www.facebook.com/rahulkrishnan.p',
      'twitter': 'https://twitter.com/rahulkrish?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/rahulkrish/',
      'email': 'rahul.krishnan@diagnal.com',
      'events': {
        'event1': 'T9'
      }
    },
    {
      'speakerID': 'S49',
      'speaker': 'Sudhahar Viswanathan',
      'profile': 'QA Lead at FAYA',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Sudhahar-Viswanathan.jpg',
      'facebook': 'https://www.facebook.com/sudhahar.viswanathan',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sudhaharv/',
      'email': 'Sudhahar.faya@gmail.com',
      'events': {
        'event1': 'T4'
      }
    },
    {
      'speakerID': 'S50',
      'speaker': 'Sajin T M',
      'profile': 'FAYA',
      'speakerdesc': '',
      'thumb': 'assets/images/thumb/Sajin-TM.jpg',
      'facebook': 'https://www.facebook.com/tmsajin',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sajin-tm-23223612/',
      'email': 'tmsajin@gmail.com',
      'events': {
        'event1': 'T1'
      }
    },
    {
      'speakerID': 'S51',
      'speaker': 'Madhav M Nair',
      'profile': 'Sr Developer for VR-AR Tech at UST Global',
      'speakerdesc': 'An Immersive Technology aficionado and Design Geek, Mr Madhav M Nair is a Unity3D Ambassador for Unity India and works as a Sr Developer for VR-AR Tech at UST Global. Being an ardent tinkerer and designer, he was a Mentor at Techtop, MIT-IIT Innovation Workshop which was recently held at IIT Delhi and has also worked as a Jr Research Fellow at Future Technologies Lab under Kerala Startup Mission.',
      'thumb': 'assets/images/thumb/Madhav-M-Nair.jpg',
      'facebook': 'https://www.facebook.com/madhav.mnair',
      'twitter': 'https://twitter.com/mmadhavnair',
      'linkedIn': 'https://www.linkedin.com/in/madhavmnair/',
      'email': '',
      'events': {
        'event1': 'C8',
        'event2': 'T62'
      }
    },
    {
      'speakerID': 'S52',
      'speaker': 'Savio Victor',
      'profile': 'AI enthusiast and entrepreneur, co-founder of air.ai and KnightClan.',
      'speakerdesc': 'Savio Victor is an AI enthusiast and entrepreneur, co-founder of air.ai and KnightClan. A jack of all trades, he has dabbled in web development and web designing before venturing into the realm of Artificial Intelligence. ',
      'thumb': 'assets/images/thumb/Savio-Victor.jpg',
      'facebook': 'https://www.facebook.com/savio.victor.7',
      'twitter': 'https://twitter.com/saviovictor1994?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/saviovictor/',
      'email': '',
      'events': {
        'event1': 'K7',
        'event2': 'C6',
        'event3': 'E1'
      }
    },
    {
      'speakerID': 'S53',
      'speaker': 'Viju Chacko',
      'profile': 'Senior Consultant at Tata Consultancy Services ',
      'speakerdesc': 'Viju Chacko is an experienced Senior Consultant at Tata Consultancy Services with a demonstrated history of working in the Information Technology and Services industry. Strong consulting professional skilled in Digital Technologies, especially in Big Data and IoT, his other focus areas include Blockchain, Deep Learning, etc.',
      'thumb': 'assets/images/thumb/Viju-Chacko.jpg',
      'facebook': 'https://www.facebook.com/anEnVi',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/vijuchacko/',
      'email': '',
      'events': {
        'event1': 'C6',
        'event2': 'E1'
      }
    },
    {
      'speakerID': 'S54',
      'speaker': 'Charles Andrews',
      'profile': 'Singularity evangelist and entrepreneur',
      'speakerdesc': 'Charles Andrews is a Singularity evangelist and entrepreneur. A futurist by philosophy and practice, Andrews is also an avid quizzer. Having architected various game models for various quiz shows both within the country and abroad, he has also headed the team behind “Pothole Go”, a satirical app that aims to better the situation of the roads in the country. The app is currently being adapted as an official road safety app for Kerala\'s PWD.',
      'thumb': 'assets/images/thumb/Charles-Andrews.jpg',
      'facebook': 'https://www.facebook.com/charlesandrews90',
      'twitter': '',
      'linkedIn': '',
      'email': '',
      'events': {
        'event1': 'C5'
      }
    },
    {
      'speakerID': 'S55',
      'speaker': 'Amarnath Sankar',
      'profile': 'CEO at CAT Entertainments Pvt Ltd & Co-Founder at TastySpots',
      'speakerdesc': 'Amarnath Sankar is the CEO at CAT Entertainments Pvt Ltd & Co-Founder at TastySpots. Apart from these, he is an entrepreneur, traveller, public speaker, strategist, poet, director and producer. He has an elaborate career with many success stories of building top notch businesses with highly competitive Digital Media Strategy.',
      'thumb': 'assets/images/thumb/Amarnath-Sankar.jpg',
      'facebook': 'https://www.facebook.com/amarnathsankar',
      'twitter': 'https://twitter.com/amarnathsankar?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/amarnath-sankar-142a59a/',
      'email': '',
      'events': {
        'event1': 'C2'
      }
    },
    {
      'speakerID': 'S56',
      'speaker': 'Abdul Muhyami Arif',
      'profile': 'Mobile developer at FantaCode',
      'speakerdesc': 'A technology enthusiast who strives to find cost-effective solutions to various problems, Abdul Muhyami Arif is a mobile developer at FantaCode whose current interest area includes Mobility and Chat Bots. He has been working on the Xamarin platform for three years, and has extensive hands-on experience in Xamarin.Android, Xamarin.Forms and Xamarin.IOS. An avid follower of the Microsoft technologies, he also develops UWP (Universal Windows Applications) applications and wishes to leverage the full power of Microsoft Azure, Mixed Reality and Bot Frameworks.',
      'thumb': 'assets/images/thumb/Abdul-Muhyami-Arif.jpg',
      'facebook': 'https://www.facebook.com/muhaym',
      'twitter': 'https://twitter.com/muhaym?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/muhaym/',
      'email': '',
      'events': {
        'event1': 'K8'
      }
    },
    {
      'speakerID': 'S57',
      'speaker': 'Pranoy Radhakrishnan',
      'profile': 'Deep Learning researcher and co-founder of air.ai',
      'speakerdesc': 'Pranoy Radhakrishnan is a Deep Learning researcher and co-founder of air.ai. The entrepreneurial bug bit him during his stint as a Software Engineer at Good Methods Global',
      'thumb': 'assets/images/thumb/Pranoy-Radhakrishnan.jpg',
      'facebook': 'https://www.facebook.com/pranoyar95',
      'twitter': 'https://twitter.com/pranoykrishnan',
      'linkedIn': 'https://www.linkedin.com/in/pranoy-radhakrishnan-63846888/',
      'email': '',
      'events': {
        'event1': 'K7'
      }
    },
    {
      'speakerID': 'S58',
      'speaker': 'Michael Gord',
      'profile': 'Founder & CEO, MLG Blockchain Consulting',
      'speakerdesc': 'Michael is a blockchain developer at TD and the founder of Bitcoin Canada and the McGill Cryptocurrency Club. While at McGill, Michael organized the Bitcoin Airdrop events where he gave hundreds of students their first bitcoin.',
      'thumb': 'assets/images/thumb/Michael-Gord.jpg',
      'facebook': 'https://www.facebook.com/michael.l.gord',
      'twitter': 'https://twitter.com/bitgord?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/mgord/',
      'email': 'michael.l.gord@gmail.com',
      'events': {
        'event1': 'T50'
      }
    },
    {
      'speakerID': 'S59',
      'speaker': 'Satish Babu',
      'profile': 'Chair, APRALO - ICANN',
      'speakerdesc': 'Programmer, Development Professional and Internet Governance Practitioner, associated with ICANN, ISOC, IEEE and InApp. Fellow and former President of Computer Society of India. Chair, APRALO, ICANN and Member, 2017 HAC, IEEE.',
      'thumb': 'assets/images/thumb/satish-babu.jpg',
      'facebook': 'https://www.facebook.com/sat1sh.babu',
      'twitter': 'https://twitter.com/satish_babu?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/sierrabravo/',
      'email': '',
      'events': {
        'event1': 'T50-1'
      }
    },
    {
      'speakerID': 'S60',
      'speaker': 'Venkatramanan P R',
      'profile': 'Data Scientist, Thought Works',
      'speakerdesc': 'Venkat is Lead Consultant and Data Scientist at ThoughtWorks. Over the last few years, he has helped build the data science capability within ThoughtWorks India, and worked with clients across several industries to deliver data science solutions. Before this, he used to work as a Physicist, working primarily in the field of phase transitions in Soft Condensed Matter systems.',
      'thumb': 'assets/images/thumb/Venkatramanan.jpg',
      'facebook': 'https://www.facebook.com/venkat.rpr',
      'twitter': 'https://twitter.com/venkatramananpr',
      'linkedIn': 'https://www.linkedin.com/in/venkatramanan-p-r-a25b0321/',
      'email': '',
      'events': {
        'event1': 'T50-2'
      }
    },
    {
      'speakerID': 'S61',
      'speaker': 'Professor Nandini Vaidyanathan',
      'profile': 'Chairman and M D, CARMa Venture Services',
      'speakerdesc': 'She’s a traveling teacher who specialises in entrepreneurship, in several Ivy League business schools around the world. <br>After 20 years in the corporate sector, working in MNC-s in all inhabited continents, she returned to India in 2005 and began teaching entrepreneurship. Realizing that the only way she could bring real time experience to her classroom was if she became an entrepreneur herself, she founded CARMa (Creating Access to Resources & Markets; www.carmaconnect.in) with a lofty ambition: to offer professional mentoring to entrepreneurs as a risk mitigating strategy. CARMa mentors start-ups, mature enterprises and family businesses. As on date, CARMa has mentored over 2000 entrepreneurs. CARMa has also been involved in mentoring women to scale from livelihood enterprises to opportunity-based and profitable organizations in Afghanistan, South and East Africa and India. Till date over 10,000 women have been mentored to build scalable and profitable enterprises. <br>A prolific writer for mainstream newspapers, portals and blogs, her first book Entrepedia: A Step by Step Guide to Becoming an Entrepreneur in India, has been a best-seller since its launch in 2011. Its second edition, updated and contemporized, came out in 2015 and has become the Bible of the start-up community. Her second book, Start up, Stand up, was published in 2016. While Entrepedia was all about how to take an idea from your head to the marketplace, Start up, Stand up is about how to grow your business from your first paying customer to an evangelical user community. <br>A TED speaker and regular jury member of television shows on business channels and entrepreneurship events across the world, she was named Business Woman of the Year by Business Goa in 2014. <br>Passionate about cooking and entertaining people, her versatility extends to the Carnatic form of music in which she is a trained singer. She currently lives in Goa.',
      'thumb': 'assets/images/thumb/nandini.jpg',
      'facebook': 'https://www.facebook.com/nandini.vaidyanathan',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/nandinivaidyanathan/',
      'email': '',
      'events': {
        'event1': 'T50-3'
      }
    },
    {
      'speakerID': 'S62',
      'speaker': 'Rama Brahmam Aleti',
      'profile': 'Co-Founder & UX Strategist, Think Design Collaborative',
      'speakerdesc': 'As a Co-founder & Director - Experience Design, at Think Design Collaborative, Rama has been instrumental in developing the company into a leading, world-class UX Design and Innovation Consultancy. As part of the core team, Rama helps in driving the company\'s strategy, business and mentor its overall growth. <br>He heads a team of over 90 Designers and has implemented 200+ UX projects in multiple domains such as - Finance, Education, Healthcare, Telecom, E-Commerce, and Entertainment. The companies include several Fortune companies, MNCs and startups. <br>In addition to leading the practice at Think Design, Rama also conducts workshops on Design Thinking, Experience Design & Innovation. Rama is a regular speaker for Product Conclave at NASSCOM Events; a warm association that has seen him conducts six such workshops. He has also been invited by IIM-A, Indian School of Business (ISB), Unicom and conducted numerous Design workshops within India, North America and South America. <br>Rama recommends initiating Design through workshop/s by inviting all stakeholders who can participate and hence collaborate in the solutioning process. He believes ‘Design Driven Innovation’ is the future and is certain that most of the businesses in this connected world will use it as a tool to stay ahead in business and innovation. <br>Rama is a Post Graduate from the prestigious National Institute of Design (NID) after doing his Graduation in Applied Arts from Jawaharlal Nehru Technological University (JNTU). An ardent Design background is what enables Rama to extend his expertise to Strategic Design, Experience Design and Design Thinking. <br>On a personal front, he loves his South Indian delicacies, is an avid movie enthusiast, a great fan of Indian films, especially his regional Telugu movies. Even whilst pursuing his geeky inclinations, he loves spending time with his family, particularly, playing with his daughter and watching her grow up.',
      'thumb': 'assets/images/thumb/rama-brahmam.jpg',
      'facebook': 'https://www.facebook.com/aleti.rama',
      'twitter': 'https://twitter.com/aletirama',
      'linkedIn': 'https://www.linkedin.com/in/aleti-rama-brahmam-127a835/',
      'email': '',
      'events': {
        'event1': 'T50-4'
      }
    },
    {
      'speakerID': 'S63',
      'speaker': 'Sanju Mathew',
      'profile': 'CEO, Onbyz',
      'speakerdesc': 'Sanju Mathew is an Mtech Electronics graduate (Signal Processing and Bionics), Entrepreneur, Intel IoT Innovator and a speaker at National and International conferences on Bionics and IoT. He is an Electronics Hardware Engineer, System Architect and UI/UX designer by choice with over 7 years of experience in these fields. His work includes a Predictive Maintenance AI for Airports (Australia), Water Supply Automation system for star hotels (USA) and Laser Calibration unit for Spectroscopy units (USA). His team built a Low Cost Bionic Hand for the disabled that focuses on modularity of sensors, custom designed feedback systems, powerful and low footprint microprocessor unit and a software architecture that makes use of Marketplace and community driven app development. Projects realized by his team was selected twice as top 10 in the world by Intel and was invited to present it at Intel Developer Forum 2015 and 2016 at San Francisco, USA. His team was awarded the runners-up prize for Mastermind competition by Dr. A P J Abdul Kalam and was one of the winners for National Level Intel IoT Hackathon 2015.',
      'thumb': 'assets/images/thumb/sanju-mathew.jpg',
      'facebook': 'https://www.facebook.com/sanjumathewk',
      'twitter': 'https://twitter.com/sanjumathew?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/sanjumathewk/',
      'email': '',
      'events': {
        'event1': 'T50-5',
        'event2': 'T80'
      }
    },
    {
      'speakerID': 'S64',
      'speaker': 'Abhilash Ashok',
      'profile': 'Senior Lead, UX Development, Valorem',
      'speakerdesc': 'An Incorruptible Passionate Microsoft Technology Stack Enthusiast with rich 8+ years’ experience, well-versed with Windows 10/UWP, Xamarin, WPF, HoloLens, Windows Phone/ Store/RT, Kinect for Windows, Xbox, Unity 3D, and legacy technologies like ASP.NET, Silverlight, ExtJS, WinForms, etc. He’s a prominent speaker in Microsoft Technology Community mainly K-MUG.<br>He completed graduation in Computer Engineering from Mahatma Gandhi University in 2007. He’s working as Technical Team Lead at Identitymine – a UX Strategy expert company, working close with Microsoft, where he’s responsible for developing premium apps and services with cutting edge technologies. Besides development, he loves mentoring & building enthusiastic team. He finds himself lucky enough to work close with MVPs and Microsoft Regional Directors.<br>He also has solid experience in airline domain, telecom domain, software and services; combined with proven experience in product life cycle, product quality, envisioning features, development and implementation. He had received various awards and laurels for his proven performance. <br>He writes about “Nerds False Positive” in his blog – CameTooFar (http://cametoofar.com/) and tweets at https://twitter.com/abhilashca.',
      'thumb': 'assets/images/thumb/abhilash-ashok.jpg',
      'facebook': 'https://www.facebook.com/abhilashca',
      'twitter': 'https://twitter.com/abhilashca',
      'linkedIn': 'https://www.linkedin.com/in/abhilashca/',
      'email': '',
      'events': {
        'event1': 'T50-6'
      }
    },
    {
      'speakerID': 'S65',
      'speaker': 'Anivar Aravind',
      'profile': 'Founder Executive Director, Indic Project',
      'speakerdesc': 'Anivar A. Aravind is Founder Executive Director of Indic Project, a civic-tech non-profit initiative works on language engineering, technology standards and digital rights.',
      'thumb': 'assets/images/thumb/anivar.jpg',
      'facebook': 'https://www.facebook.com/an1var/',
      'twitter': 'https://twitter.com/anivar',
      'linkedIn': 'https://www.linkedin.com/in/anivar/',
      'email': '',
      'events': {
        'event1': 'T50-7'
      }
    },
    {
      'speakerID': 'S66',
      'speaker': 'Mohammed Rafi T F',
      'profile': 'Behavioural Scientist, Life Transformation Specialist and International Master Trainer, Neuro Lingusitic Programme',
      'speakerdesc': 'A Behavioural Scientist, Life Transformation Specialist and International Master Trainer in Neuro Lingusitic Programme with more than 13 years of experience in various streams ranging from Information Technology to Education to Retail and Insurance. <br>Have heart fully trained more than 100 thousand people ranging from CEO’s to Celebrities to Billion Dollar Entrepreneurs. Was instrumental in coaching and mentoring senior managers and CEO’s of Corporate, Government, Private Sector and NGO’s to bring out the best in them and achieve excellence in their respective fields. A creative professional who applies his heart and soul into any assignment that he takes, and transforms the lives of those he comes across in his training programs and one to one coaching sessions. <br> He is one of the only two trainers from Asia to be directly mentored by NLP Co-Creator Dr.John Grinder. He is also the Peak performance coach for Indian Junior Girls Gymnastics team and he is the personal NLP Coach for the National Award Winning Malayalam Actor Jayasurya. Some of Rafi’s esteemed clients include Organizations like Coca Cola, Lupin Pharma, Allianz Group, Reliance Industries, E&Y, LIC and many more. Currently he is pursuing research in Behavioural Neuropsychology, NLP, Micro Expression Patterns and Provocative Coaching. ',
      'thumb': 'assets/images/thumb/rafi.jpg',
      'facebook': 'https://www.facebook.com/mohammed.rafi.71619',
      'twitter': 'https://twitter.com/morafiindia',
      'linkedIn': '',
      'email': '',
      'events': {
        'event1': 'T50-8'
      }
    },
    {
      'speakerID': 'S67',
      'speaker': 'M Sivasankar IAS',
      'profile': 'IT Secretary, Government of Kerala',
      'speakerdesc': 'Shri. M Sivasankar is presently the Secretary to Government, IT Department since June, 2016. He is also holding the charge of Officer on Special Duty to the Chief Minister of Kerala.<br>Sivasankar an Engineering Graduate and a Master of Business Administration (MBA) started his career as an officer in the Reserve Bank of India. He was subsequently appointed as Deputy Collector to the Government. While in service he was selected to the Indian Administrative Service (IAS) in 1995 which is the highest bureaucratic position in administrative service of India. ',
      'thumb': 'assets/images/thumb/sivasankar.jpg',
      'facebook': 'https://www.facebook.com/sivasankar.nair.9',
      'twitter': '',
      'linkedIn': '',
      'email': '',
      'events': {
        'event1': 'T50-9'
      }
    },
    {
      'speakerID': 'S68',
      'speaker': 'Dr. Asharaf S',
      'profile': 'Associate Professor, IIITMK',
      'speakerdesc': 'Asharaf S is an Associate Professor at Indian Institute of Information Technology and Management – Kerala. He is also serving as a visiting faculty in Indian Institute of Space Science and Technology, Trivandrum and as a Mentor in Kerala Startup Mission. He received his PhD and Master of Engineering degrees in Computer Science from Indian Institute of Science, Bangalore. He graduated in Computer Engineering from Cochin University of Science and Technology. After his PhD he has worked with America Online (AOL) and IIM Kozhikode. He is a recipient of IBM outstanding PhD student award 2006, IBM Shared University Research Grant 2015 and IBM OSCP Grant 2017. He has published three books and more than 30 research papers in international journals and conferences. His areas of interest include technologies and business models related to machine learning, web mining, intelligent internet of things and blockchains.',
      'thumb': 'assets/images/thumb/ashraf.jpg',
      'facebook': 'https://www.facebook.com/profile.php?id=686189585',
      'twitter': 'https://twitter.com/asharafs',
      'linkedIn': 'https://www.linkedin.com/in/asharafs/',
      'email': '',
      'events': {
        'event1': 'T50-9'
      }
    },
    {
      'speakerID': 'S69',
      'speaker': 'Rahul Alex Panicker',
      'profile': 'Co-founder & President, Embrace Innovations',
      'speakerdesc': 'A technology product leader, Mr. Panicker loves building and leading creative teams to actualize magical products. He spends his time with users, working with designers, engineers, marketers, and sales folks to create these products, and taking them to market, giving them lots of TLC, and having their magic spread. As co-founder and president of Embrace, which has helped over 250,000 vulnerable babies in the developing world, since 2012, his next mission is to transform the world through AI. ',
      'thumb': 'assets/images/thumb/rahul-alex.jpg',
      'facebook': 'https://www.facebook.com/rahul.alex.panicker',
      'twitter': 'https://twitter.com/rahulapanicker',
      'linkedIn': 'https://www.linkedin.com/in/rahulap/',
      'email': '',
      'events': {
        'event1': 'T50-9'
      }
    },
    {
      'speakerID': 'S70',
      'speaker': 'Anoop Ambika',
      'profile': 'Founder, CLAP Research',
      'speakerdesc': 'Anoop P Ambika is a serial entrepreneur, organiser and a technology enthusiast. He is the co-founder of several technology/ environment startups and currently is Chief Executive Officer of CLAP Research and Genpro Life Sciences. <br>CLAP Research brings together a team of Machine Learning, Statistics, NLP and Cognitive Neuroscience specialists to enable the transition of enterprise applications from deterministic systems to implicit learning systems. ',
      'thumb': 'assets/images/thumb/anoop.jpg',
      'facebook': 'https://www.facebook.com/anoop.ambika',
      'twitter': 'https://twitter.com/anoopambika',
      'linkedIn': 'https://www.linkedin.com/in/anoopambika/?ppe=1',
      'email': '',
      'events': {
        'event1': 'T50-9'
      }
    },
    {
      'speakerID': 'S71',
      'speaker': 'Pinaki Krishna Pillai',
      'profile': 'Founder, Microm CRM',
      'speakerdesc': 'Pinaki Krishna Pillai has been exploring options to bridge marketing with technology. He has associated with 30+ companies to set up and run effective marketing processes, strategies and campaigns. He is also a certified marketer from Google and Hubspot.',
      'thumb': 'assets/images/thumb/Pinaki-Krishna-Pillai.jpg',
      'facebook': '',
      'twitter': 'https://twitter.com/pinakipillai?lang=en',
      'linkedIn': 'https://www.linkedin.com/in/pinakipillai/',
      'email': '',
      'events': {
        'event1': 'E2'
      }
    },
    {
      'speakerID': 'S72',
      'speaker': 'Dilip Mathew Thomas',
      'profile': 'Independent Consultant- Deep Learning',
      'speakerdesc': 'He is an independent consultant and works in the areas of deep learning for computer vision, computer graphics, and data analysis and visualization. He holds a Ph.D. and a Master’s degree in Computer Science and Engineering from the Indian Institute of Science, Bangalore and a Bachelor’s degree in Computer Science and Engineering from National Institute of Technology, Calicut. He has around 15 years of combined experience as a researcher and an engineer and has several publications in top tier journals and conferences. He is the first student from India to publish a paper at IEEE VIS, the premier forum for advances in visualization, and was also presented the CSA-IBM India Research Labs\' Best Thesis award.',
      'thumb': 'assets/images/thumb/Dilip-Mathew-Thomas.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/dilip-thomas-83b355a0/',
      'email': '',
      'events': {
        'event1': 'T59',
        'event2': 'C11'
      }
    },
    {
      'speakerID': 'S73',
      'speaker': 'Sreeraj S',
      'profile': 'Chief Architect of Servntire Global',
      'speakerdesc': 'Entrepreneur and technology expert, Mr. Sreeraj S is the Co-Founder and Chief Architect of Servntire Global, a company focusing on blockchain solutions. He has contributed to the development of various blockchain platforms and has set up enterprise grade solutions for companies, helping them transform their business. Speaker and blogger, he is a blockchain evangelist and an advocate of decentralised applications.',
      'thumb': 'assets/images/thumb/Sreeraj-S.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sreeraj-s/',
      'email': '',
      'events': {
        'event1': 'T61'
      }
    },
    {
      'speakerID': 'S74',
      'speaker': 'Sarath Soman',
      'profile': 'Software Engineer at Hifx',
      'speakerdesc': 'Sarath Soman is a Software Engineer at Hifx with expertise in building middlewares at higher scales. His primary interest is in compiler engineering and has ported SLANGforDotNet to JVM with support to Lambda expressions and local variable type inference. Apart from compilers, he is in the process of bootstrapping a Machine Learning library like JAMA and WEKA from scratch. Recently he has been dabbling in writing LKMs and native code interfacing with Java, C# and Python.',
      'thumb': 'assets/images/thumb/Sarath-Soman.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sarath-soman-3a3aa564/',
      'email': '',
      'events': {
        'event1': 'C9'
      }
    },
    {
      'speakerID': 'S75',
      'speaker': 'Mahroof K',
      'profile': 'Cedex Technologies LLP',
      'speakerdesc': 'Mahroof K is a technology enthusiast & business analyst. He co-founded Cedex Technologies LLP, a Chatbot, Web and Mobile Development company in Kochi. He holds a Masters Degree in Computer Application from College of Engineering, Trivandrum, and also holds an MBA. For the past four years, he has been providing solutions to startups worldwide in the areas of chatbot, web and mobile development.',
      'thumb': 'assets/images/thumb/Mahroof-K.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/mahroofk/',
      'email': '',
      'events': {
        'event1': 'C10'
      }
    },
    {
      'speakerID': 'S87',
      'speaker': 'Renjith Raj',
      'profile': 'Chief Technical Officer at SayOne Technologies',
      'speakerdesc': 'As a technophile with close to a decade of experience in creating innovative technology solutions, Renjith plays the role of Chief Technical Officer at SayOne Technologies. His persistent efforts have been to create feature-rich technology architectures for clients around the globe. An entrepreneur at the same time, Renjith keenly observes the ever-evolving industry changes and keeps both his team and clients ahead of the competition. He has demonstrated experience and expertise in top-notch technology tools such as Django, Blockchain, Elastic Search, Angular JS, Android & Flutter, and languages such as Golang, Python, Java, Dart, SQL.',
      'thumb': 'assets/images/thumb/Renjith-raj.jpg',
      'facebook': '',
      'twitter': 'https://twitter.com/renjithraj2005',
      'linkedIn': 'https://www.linkedin.com/in/renjithraj2005/',
      'email': '',
      'events': {
        'eventID': 'K16'
      }
    },
    {
      'speakerID': 'S95',
      'speaker': 'Simsarul Haq Vengasseri',
      'profile': 'Quantum Computing Researcher, Infinity Labs, UST',
      'speakerdesc': 'Simsar is a quantum computing researcher and enthusiast at Infinity Labs, UST Global. He holds a Bachelor of Technology degree in Computer Science and Engineering from National Institute of Technology, Calicut. Currently, he is working in the design and development of Quantum Algorithms and its applications in various domains. His work includes the mathematical and computational analysis of quantum algorithms.',
      'thumb': 'assets/images/thumb/simsar.jpg',
      'facebook': 'https://www.facebook.com/simsarulhaq.vengasseri',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/simsarul-haq-vengasseri-65a2b8a3/',
      'email': 'simsarulhaqv@gmail.com',
      'events': {
        'event1': 'T69',
        'event2': 'C20',
        'event3': 'K23'
      }
    },
    {
      'speakerID': 'S111',
      'speaker': 'Hari Shankar R',
      'profile': 'Technical Support Engineer, Automattic',
      'speakerdesc': 'Hari Shanker R is a Technical Support Engineer at Automattic - the U.S.- based company - that is best known for WordPress.com. Hari has over 12 years of experience in web development - especially WordPress. At Automattic, he works on the eCommerce team, where he works on support, training, and product management for WooCommerce - the open eCommerce platform built on WordPress that powers 28% of all eCommerce stores. Hari has used WordPress to build over 100+ websites and web applications of varying complexities for diverse clients including Fortune 500 companies, prior to joining Automattic. WordPress, FOSS, the GPL License, and the Open Web are his biggest passions, which is what led him to Automattic. A seasoned contributor to the WordPress open-source project (for the support as well as the community team), Hari has delivered talks on WordPress at different events including WordCamps (WordPress-based conferences) across India and North America. Hari is one of the co-organizers of the WordPress Kochi Meetup Group as well as WordCamp Kochi 2019 (the third edition of the first-ever WordPress conference in South India).<br>Prior to joining Automattic in 2016, Hari has worked in a diverse set of domains including Retail Banking, Print Journalism, Education/Training, Project Management, and Social Media Marketing, to name a few. A former columnist at The Hindu, and has also won awards for his work, including the runner-up position at the 2011 Mindful Leadership Award from the University of Dayton, Ohio. You can read more about Hari at https://harishanker.net and https://hari.blog.',
      'thumb': 'assets/images/thumb/harishanker.jpg',
      'facebook': 'https://www.facebook.com/harishanker',
      'twitter': 'https://twitter.com/HariShanker',
      'linkedIn': 'https://www.linkedin.com/in/harishanker/',
      'email': 'hari@harishanker.net',
      'events': {
        'event1': 'T78',
        'event2': 'C28',
        'event3': 'K26'
      }
    },
    {
      'speakerID': 'S122',
      'speaker': 'Amrit Sanjeev',
      'profile': 'Staff Developer Advocate at Google and leads the developer advocacy initiatives for India.',
      'speakerdesc': 'Amrit Sanjeev works as a Staff Developer Advocate at Google and leads the developer advocacy initiatives for India. He has over 15 years of industry experience and has worked in different areas like OS development, large scale backend systems design, software architecture and mobile research. Prior to Google he worked in companies like Inapp, IBM, Intuit & Philips Research. He was the first person from India to be accepted as a Google developer expert for Android and as an Intel innovator. He is the founder of Blrdroid - the largest open android developer community in India and a total petrol head .',
      'thumb': 'assets/images/thumb/amrit-sanjee.jpg',
      'facebook': 'https://www.facebook.com/amrit.sanjeev',
      'twitter': 'https://twitter.com/amsanjeev',
      'linkedIn': 'https://www.linkedin.com/search/results/all/?keywords=Amrit%20Sanjeev&origin=GLOBAL_SEARCH_HEADER',
      'email': '',
      'events': {
        'event1': 'T84'
      }
    },
    {
      'speakerID': 'S123',
      'speaker': 'Mandar Patil ',
      'profile': 'Senior Solutions Architecture at Amazon Internet Services Private Limited.',
      'speakerdesc': 'Mandar Patil is Senior Solutions Architecture at Amazon Internet Services Private Limited. He has been working various public sector customers include State and Local Government, Education and Non-Profits in India to help their cloud journey. He has worked in various technology roles at customers like GE Healthcare, Apple, Ingram Micro as. He studied Engineering from Mumbai University and post-graduation in advanced software technology from NCST. Nikhil Krishna is a Solutions Architect working in UST Global with over 16 years of experience in IT Consulting and Product Development. His areas of interest include Reactive and Distributed Systems Programming Languages and Bitcoin. He is passionate about programming for the web and its potential as a tool to transform user experience. His career spans across diverse roles from Dev Ops to Developer to Quality Assurance to Product Owner. Jyothis Joseph is an entrepreneur by passion and has over 16 years of experience in the IT industry, leading global teams comprising of Operations, Technology, and Sales. Jyothis founded two companies, Ideamine, a managed cloud company in 2009, and Empressem, a Mobile Apps company in 2014. Ideamine was AWS Advanced partner since 2012 and they were awarded as best emerging partners for AWS in 2016. Both Ideamine and Empressem were acquired by Chicago based Netrix ( netrixllc.com) in Oct 2017. He is a sports evangelist and a Marathon runner. He successfully finished his Ironman 70.3 tittle in Bangkok recently.',
      'thumb': 'assets/images/thumb/mandar-patil.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': '',
      'email': '',
      'events': {
        'event1': 'T86'
      }
    },
    {
      'speakerID': 'S126',
      'speaker': 'Melvin Thambi',
      'profile': 'Artist | Designer & Creative Entrepreneur from Texas',
      'speakerdesc': 'Creative Entrepreneur & NFT Artist. Co-Founder of Emm & Enn Art Gallery. Designer with a business focus. I help creative individuals convert passion to tangible wealth. Over 14 years of global experience influencing product design with brands including Facebook, LinkedIn, & eBay.',
      'thumb': 'assets/images/thumb/melvin_thambi.jpg',
      'facebook': 'https://www.facebook.com/melvinthambiart',
      'twitter': 'https://twitter.com/ThambiMelvin',
      'linkedIn': 'https://www.linkedin.com/in/melvinthambi/',
      'email': 'hello@melvinthambi.com',
      'events': {
        'eventID': 'T87'
      }
    },
    {
      'speakerID': 'S127',
      'speaker': 'Anantha Krishnan Nadamel',
      'profile': 'NFT Artist | Visual Designer UXD at TCS Interactive',
      'speakerdesc': 'Digital artist and designer from Kerala in India. Featured by Adobe, Behance, Wacom Gallery, Indian Express, Hindu and Forbes India.',
      'thumb': 'assets/images/thumb/Anantha-Krishnan-Nadamel.jpg',
      'facebook': 'https://www.facebook.com/ananthakrishnan.skurup',
      'twitter': 'https://twitter.com/ANadamel',
      'linkedIn': 'https://www.linkedin.com/in/anantha-krishnan-s-kurup-301134176/?originalSubdomain=in',
      'email': '',
      'events': {
        'eventID': 'T88'
      }
    },
    {
      'speakerID': 'S128',
      'speaker': 'Adeeb Abdul Salam',
      'profile': 'Computer Engineer from IITD | Blockchain Researcher',
      'speakerdesc': ' ',
      'thumb': 'assets/images/thumb/Adeeb-Abdul-Salam.jpg',
      'facebook': 'https://www.facebook.com/adeeb.abdulsalam',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/zeroknowledgep/?originalSubdomain=qa',
      'email': '',
      'events': {
        'eventID': 'T89'
      }
    },
    {
      'speakerID': 'S129',
      'speaker': 'Dr. Koshy P. Vaidyan',
      'profile': 'CEO, TrEST Research Park',
      'speakerdesc': 'Dr. Koshy P. Vaidyan has more than two decades of experience in Global Tier 1 organizations like Ernst & Young and Tata Consultancy Services, and in Government. His expertise extends to the fields of Enterprise & Business Architecture, Business Process Transformation, and Business / IT Strategy.',
      'thumb': 'assets/images/thumb/Koshy-P-Vaidyan.jpg',
      'facebook': 'https://www.facebook.com/people/Koshy-P-Vaidyan/100001538916933/',
      'twitter': 'https://twitter.com/koshypv',
      'linkedIn': 'https://www.linkedin.com/in/dr-koshy-p-vaidyan-9868aa29/?originalSubdomain=in',
      'email': '',
      'events': {
        'eventID': 'T90'
      }
    },
    {
      'speakerID': 'S130',
      'speaker': 'Gautam S.T.',
      'profile': 'Director, Gyanoholic International Pvt. Ltd.',
      'speakerdesc': 'Gautham is an Electronics and Communications Engineer who specializes in Robotics, Electronics, Programming, 3D printing, Automobile Engineering. He is also the co-founder and director of Gyanoholic International Pvt. Ltd.',
      'thumb': 'assets/images/thumb/Gautam-S-T.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/gautamst/?originalSubdomain=in',
      'email': '',
      'events': {
        'eventID': 'T91'
      }
    },
    {
      'speakerID': 'S131',
      'speaker': 'Abhaya Kumar K R',
      'profile': 'Senior Manager (Product Management), Edgeverve BFSI',
      'speakerdesc': 'Abhaya Kumar is a Financial Services Product Executive with 21 years of experience and is passionate about driving product development initiatives from ideation to rollout. He is an expert in identifying market needs, prioritizing, defining, planning, and executing strategic objectives on new Products & Solutions for various markets.',
      'thumb': 'assets/images/thumb/abhaya-kumar.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/abhaya-kumar-k-r-b94370/',
      'email': '',
      'events': {
        'eventID': 'T92'
      }
    },
    {
      'speakerID': 'S132',
      'speaker': 'Don Peter',
      'profile': 'Co-founder and CTO at Finotes Inc.',
      'speakerdesc': 'Don Peter is the Co-founder and Chief Technology Officer of Finotes - a lightweight SDK that captures and reports bugs in mobile apps. It is capable of detecting memory leaks, ANRs, App Hangs, Crashes, Slow & Frozen frames, HTTP call related issues, screen load delays, and much more. Don has 10+ years of experience in developing mobile applications and backend app development and worked on multiple frameworks with languages like Java, Objective-C, Kotlin, Dart, Swift, Python, and Ruby.',
      'thumb': 'assets/images/thumb/don-peter.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/donpeter06/',
      'email': '',
      'events': {
        'eventID': 'T93'
      }
    },
    {
      'speakerID': 'S133',
      'speaker': 'Sujith S',
      'profile': 'Partner & Senior AI/ML Solution Architect, Zackriya Solutions.',
      'speakerdesc': 'Sujith is the Partner and Senior AI/ML Solution Architect at Zackriya Solutions. Also, an Entrepreneur at heart, Sujith has over half a decade of experience in delivering machine learning and analytics solutions to many midsize to large organizations across the globe. His extensive expertise in Data Science, Machine Learning, and AI has been built from projects from his startup days and is fortified with coursework from universities such as Harvardx.',
      'thumb': 'assets/images/thumb/sujith-s.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sujithx007/?originalSubdomain=in',
      'email': '',
      'events': {
        'eventID': 'T94'
      }
    },
    {
      'speakerID': 'S134',
      'speaker': 'Mr. Andrew Bastin',
      'profile': 'Co-Founder & CTO, Hoppscotch.',
      'speakerdesc': 'Andrew Bastin is the Co-Founder and Chief Technology Officer at Hoppscotch. Primarily a Full Stack web developer, Andrew also has a solid grasp and experience working on various technologies from mobile app development to native systems programming.',
      'thumb': 'assets/images/thumb/andrew-bastin.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/andrew-bastin-7456771a8/?originalSubdomain=ca',
      'email': '',
      'events': {
        'eventID': 'T95'
      }
    },
    {
      'speakerID': 'S135',
      'speaker': 'Gurudath Sadanandan',
      'profile': 'Gurudath is the founder of \'Videogrammer\' - a Microsoft-funded project for Startups.',
      'speakerdesc': 'He is a self-starter, who explores the world through the unique perspective of media, technology, and art. An educator by profession, he is gifted in simplifying complex technology and has conducted workshops across the globe for spreading awareness of technology and art in everyday life.',
      'thumb': 'assets/images/thumb/gurudath-sadanandan.png',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/gurudath-sadanandan/?originalSubdomain=in',
      'email': '',
      'events': {
        'event1': 'T96',
        'event2': 'C35'
      }
    },
    {
      'speakerID': 'S136',
      'speaker': 'Febna V M',
      'profile': 'AI Security Specialist, Beagle Security',
      'speakerdesc': 'Febna is a technology evangelist with advanced skills in cyber security. Currently, she is a Cyber Security Engineer at Beagle Cyber Innovations.',
      'thumb': 'assets/images/thumb/febna.png',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/febnavm/',
      'email': '',
      'events': {
        'event1': 'T97'
      }
    },
    {
      'speakerID': 'S137',
      'speaker': 'Renju R',
      'profile': 'Director of Digital Marketing, FAYA',
      'speakerdesc': 'Renju is a marketing specialist with 12+ years of experience in framing sales, devising marketing strategies, managing a social media presence, and developing products. An effective leader and mentor, he has recruited, trained, and coached high-performing marketing teams for SaaS, eCommerce, IT & EdTech businesses.',
      'thumb': 'assets/images/thumb/renju_r.jpg',
      'facebook': 'https://www.facebook.com/renju.raju.5',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/renju-r-407a1a62/',
      'email': '',
      'events': {
        'event1': 'T98'
      }
    },
    {
      'speakerID': 'S138',
      'speaker': 'Deepa KC',
      'profile': 'Head of Infrastructure and Information Security, Allianz Technology India',
      'speakerdesc': 'Deepa is an accomplished Senior Technology Leader with 21+ years of senior IT leadership and management experience, directing large global teams. She has a strong background in banking and insurance (BFSI). In her previous roles she fuelled digital transformation at a very fast pace underpinned by agile and culture transformation. Deepa led the implementation of “cloud first” strategy and adopted DevOps and SRE framework.',
      'thumb': 'assets/images/thumb/deepa.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/deepa-k-c-9aa40180/?originalSubdomain=in',
      'email': '',
      'events': {
        'event1': 'T99'
      }
    },
    {
      'speakerID': 'S139',
      'speaker': 'Bijesh M.B',
      'profile': 'Cheminformatist, Calpine',
      'speakerdesc': 'A passionate organic chemist with a PhD in Organic Chemistry from IIT Delhi, Bijesh has experience as a Subject Matter Expert in the Reaxys team at a global corporation. His expertise in chemistry and flair for communicating his knowledge with technology professionals makes him hugely popular in his team at UVJ Technologies (Calpine). Apart from work, Bijesh enjoys cricket and chess.',
      'thumb': 'assets/images/thumb/bijesh.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': '',
      'email': '',
      'events': {
        'eventID': 'C34'
      }
    },
    {
      'speakerID': 'S140',
      'speaker': 'Ranjith Rajan Pillay',
      'profile': 'Project Manager, Calpine',
      'speakerdesc': 'Ranjith is an IT professional with more than 20 years of rich experience in the field of Information Technology. He is an alumnus of National Institute of Technology, Warangal and has worked with global clients. For the last 6 years at UVJ Technologies (Calpine), he has been actively managing and delivering projects in the life science domain for major clients. A passionate technology enthusiast, Ranjith also loves outdoor sports and is a chess aficionado.',
      'thumb': 'assets/images/thumb/ranjith_rajan.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': '',
      'email': '',
      'events': {
        'eventID': 'C34'
      }
    },
    {
      'speakerID': 'S141',
      'speaker': 'Sunny Gupta',
      'profile': 'Engineering Leader, Atlassian',
      'speakerdesc': 'Sunny Gupta is an accomplished Engineering Manager with Atlassian, one of the leading software companies in the world. His passion for coding started at the young age of 12, and since then, he has spent over a decade in the industry, working across various verticals such as eCommerce, SaaS, Fashion-Tech, Med-Tech, and Media, among others.',
      'thumb': 'assets/images/thumb/sunny.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/sunnykgupta/',
      'email': '',
      'events': {
        'event1': 'T100'
      }
    },
    {
      'speakerID': 'S142',
      'speaker': 'Anish Aravind',
      'profile': 'Co-Founder & Principal Consultant, SS Consulting',
      'speakerdesc': 'Mr. Anish Aravind is a renowned human resource professional with over 16 years of experience in the manufacturing, FMCG, ITES, and IT industry segments. Mr. Aravind is also a seasoned OD and HR consultant with over 8 years of experience in the field. Mr. Aravind is currently the co-founder and principal consultant at SS Consulting and has served as the Secretary of the National Institute of Personnel Management from 2016-2021. He was recently recognized as one of the top 20 HR Influencers in 2023 by ET\'s ETHR World.',
      'thumb': 'assets/images/thumb/anish-aravind.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/anisharavind/',
      'email': '',
      'events': {
        'event1': 'T100'
      }
    },
    {
      'speakerID': 'S143',
      'speaker': 'Shruti Balasa',
      'profile': 'Shruti Balasa is a full-stack web developer and tech educator',
      'speakerdesc': 'Shruthi is also a top-rated instructor with courses on Udemy, LinkedIn Learning, and YouTube. She has published eBooks that aim to simplify web development for beginners and her first eBook Complete Guide to CSS Flex & Grid has sold over 1400 copies across 80 countries.',
      'thumb': 'assets/images/thumb/shruti-balasa.jpg',
      'facebook': '',
      'twitter': 'https://twitter.com/shrutibalasa',
      'linkedIn': 'https://www.linkedin.com/in/shrutibalasa/ ',
      'email': '',
      'events': {
        'event1': 'T101'
      }
    },
    {
      'speakerID': 'S144',
      'speaker': 'Ashish Anil Abraham',
      'profile': 'Lead Engineer, UX, QBurst ',
      'speakerdesc': 'Ashish is a Lead UX Engineer at QBurst with over 7 years of experience in the field. He is passionate about creating sublime digital experiences that help people achieve their goals. He is also an avid enthusiast of all things tech, design, gaming, and automobile',
      'thumb': 'assets/images/thumb/ashish-anil-abraham.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/imashishanil',
      'email': '',
      'events': {
        'event1': 'T102'
      }
    },
    {
      'speakerID': 'S145',
      'speaker': 'Anjali Reghu',
      'profile': 'Senior User Experience Designer, Cusmat Technologies ',
      'speakerdesc': 'With a unique journey that bridges the worlds of architecture and digital design, Anjali is a User Experience Designer who started her career as an Architect. She currently works as a Senior User Experience Designer at Cusmat Technologies, Bengaluru. Combining the best of both physical and digital design worlds, she is passionate about crafting seamless experiences that enhance users\' interactions with the world around them.',
      'thumb': 'assets/images/thumb/anjali-reghu.jpg',
      'facebook': '',
      'twitter': 'https://twitter.com/anjali_reghu ',
      'linkedIn': '',
      'email': '',
      'events': {
        'event1': 'T103'
      }
    },
    {
      'speakerID': 'S146',
      'speaker': 'Sreejith Nair',
      'profile': 'Brand Marketing Communication Leader',
      'speakerdesc': 'Sreejith\'s love affair with brands and the power of stories had been natural, intuitive, and seamless. He had been hooked on it since childhood, and now it was his career!. <br> He had led marketing teams at Reliance Retail, IndusInd Bank, CSB Bank, Kotak Mahindra Bank, and currently, he was working at one of the Big4 professional services firms. His goal had been to synthesize new-age technology and age-old marketing concepts. Donning his work hat made him a chaos tamer and an innovative thinker.',
      'thumb': 'assets/images/thumb/sreejith-nair.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/mrsreejithnair/',
      'email': '',
      'events': {
        'event1': 'T105'
      }
    },
    {
      'speakerID': 'T147',
      'speaker': 'Binish Moulana',
      'profile': 'Head of Platform Enablement APAC, Finastra',
      'speakerdesc': 'Binish Moulana is an accomplished professional with over 22 years of experience in the software industry, demonstrating proven expertise in leading teams to architect solutions, with a particular emphasis on SRE and Automation on Cloud. His passion lies in driving innovation and modernization while ensuring the delivery of high-quality services to clients. <br> As a Cloud Architect on AWS and Azure, Binish Moulana has successfully delivered cloud-native solutions and facilitated platform adoption focusing on AIOps. Currently, he is researching generative AI-based automation and AI ethics.',
      'thumb': 'assets/images/thumb/binish-moulana.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/binish-moulana/',
      'email': '',
      'events': {
        'event1': 'T106'
      }
    },
    {
      'speakerID': 'T148',
      'speaker': 'Amal Shehu',
      'profile': 'Co-Founder, StoryBrain',
      'speakerdesc': 'Amal transcended beyond being a quintessential tech enthusiast into a futurist who worships the transformative power of technology. A chemist of Technology, Amal brews innovative, smart solutions that present a gateway for brands to optimize their workflows by wielding the right technologies the right way.',
      'thumb': 'assets/images/thumb/Amal-Shehu.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/amalshehu',
      'email': '',
      'events': {
        'event1': 'T107'
      }
    },
    {
      'speakerID': 'T149',
      'speaker': 'Jugal J',
      'profile': 'Application Security Specialist, EY GDS',
      'speakerdesc': 'A senior cyber security consultant at EY GDS with more than 4 years of Industry experience in offensive security. His primary focus areas include penetration testing and application security(DAST) for web, web services, mobile and network infrastructure. <br>He is currently working on innovation and automation of application security operations and building new cyber security solutions. <br> Jugal is a tech enthusiast with a passion for emerging technologies.',
      'thumb': 'assets/images/thumb/jugal.jpg',
      'facebook': '',
      'twitter': '',
      'linkedIn': 'https://www.linkedin.com/in/jugal-j-59a81111a ',
      'email': '',
      'events': {
        'event1': 'T108'
      }
    }
  ];

  showModal(speaker: any) {
    this.selectedSpeaker = speaker;
    this.speakerModal.nativeElement.open = !this.speakerModal.nativeElement.open;
  }

  onError(event: any) {
    event.target.src = this.defaultImage;
  }
}
